<template>
  <div class="post-wrapper" style="cursor: text !important">
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <div class="row" style="
            display: flex;
            /* justify-content: center;  */
            /* align-items: center; */
            width: 100%;
            margin-left: 0px !important;
            margin-right: 0px !important;
          ">
          <div class="col-md-8 p-l-0 d-none">
            <div class="row">
              <div class="col-md-3 col-sm-3 col-12">
                <div class="sort-el" style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                  ">
                  <div class="form-group input-group input-group-right transparent m-b-0 m-t-0" id="post-sort">
                    <select name="sort" v-model="sort" class="form-control"
                      style="height:2.55rem;border-right: none !important;">
                      <option value="esmr">Terpopuler</option>
                      <option value="date">Terbaru</option>
                      <option value="dateOld">Terlama</option>
                      <option value="engagement">Engagement</option>
                    </select>
                    <div class="input-group-append" style="border-left:none !important">
                      <span class="input-group-text transparent">
                        <i class="bi bi-sort-down-alt" style="font-size: 18px" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-12 m-t-10 mt-md-0">
                <div class="perpage-el">
                  <div class="form-group input-group input-group-right transparent m-b-0 m-t-0" id="post-per-page">
                    <select name="sort" v-model="per_page" class="form-control"
                      style="height:2.55rem;border-right: none !important;">
                      <option value="10">10 Post per Halaman</option>
                      <option value="25">25 Post per Halaman</option>
                      <option value="50">50 Post per Halaman</option>
                      <option value="100">100 Post per Halaman</option>
                      <option value="500">500 Post per Halaman</option>
                      <option value="1000">1000 Post per Halaman</option>
                    </select>
                    <div class="input-group-append">
                      <span class="input-group-text transparent">
                        <i class="bi bi-file-earmark-break" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-12 m-t-10 mt-md-0">
                <div class="perpage-el">
                  <div class="form-group input-group input-group-right transparent m-b-0 m-t-0" id="post-pers-filter">
                    <select name="sort" v-model="isPers" class="form-control"
                      style="height:2.55rem;border-right: none !important;">
                      <option value="2">Tampilkan Semua</option>
                      <option value="1">Tampilkan Pers</option>
                      <option value="0">Tampilkan Non Pers</option>
                    </select>
                    <div class="input-group-append">
                      <span class="input-group-text transparent">
                        <i class="bi bi-eye" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-12 m-t-10 mt-md-0">
                <div class="perpage-el">
                  <div class="form-group input-group input-group-right transparent m-b-0 m-t-0" id="post-tier-filter">
                    <multiselect v-model="multiple_tier" :options="tier_options" :multiple="true" :limit="1"
                      :searchable="false" placeholder="Semua Tier" label="name" track-by="name" @input="tierChanged">
                      <template slot="limit">
                        <span class="multiselect__strong">
                          +(
                          {{
                      Array.isArray(multiple_tier)
                        ? multiple_tier.length - 1
                        : 0
                    }})
                        </span>
                      </template>
                    </multiselect>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 p-r-0 m-t-10 mt-md-0">
            <div class="d-flex">
              <form action="#" id="post-search-form" @submit.prevent="searchPost" class="ml-auto mr-2 w-100">
                <div class="form-group-lg input-group position-relative">
                  <input type="text" placeholder="Cari..." v-model="search" class="form-control input-search"
                    style="height:2.55rem; padding-left: 40px;" />
                  <i class="bi bi-search"
                    style="position: absolute; padding: 10px 16px; color: #9DA3A8 !important; z-index: 10;" />
                  <!-- <div class="input-group-append">
                    <span
                      @click="searchPost"
                      class="input-group-text complete"
                      style="cursor: pointer; border: none !important"
                    >
                    </span>
                  </div> -->
                </div>
              </form>
              <button id="advance" class="btn bg-filter text-gray-300"
                style="cursor: pointer; padding-left: 5px; padding-right: 5px" v-tooltip.top="{ ref: 'advance-search' }"
                @click="showAdvanceSearch()">
                Filter
                <i class="bi bi-funnel-fill ml-1"></i>
              </button>
              <div ref="advance-search" class="tooltip-content">
                <b>Advance Search</b>
              </div>
              <button v-if="isFilter" @click="resetFilter" class="btn btn-danger ml-2" style="cursor: pointer">
                <i class="bi bi-trash" />
              </button>
            </div>
          </div>
        </div>
        <div class="row m-t-10" style="
            display: flex;
            justify-content: end;
            width: 100%;
            margin-left: 0px !important;
            margin-right: 0px !important;
          ">
          <div v-if="tipe_project == 1" :class="isAdmin ? 'col-md-4' : 'col-md-5'">
            <div class="form-check warning m-b-0" style="
                vertical-align: middle !important;
                display: inline-block;
                line-height: normal;
              " id="post-highlight">
              <input type="checkbox" v-model="is_highlight" id="showHighlight" />
              <label class="text-nowrap" for="showHighlight">
                Tampilkan hanya yang dihighlight
              </label>
            </div>
          </div>

          <div v-if="isAdmin" class="col-md-2">
            <div class="form-check success m-b-0" style="
                vertical-align: middle !important;
                display: inline-block;
                line-height: normal;
              " id="post-tandai-semua">
              <input type="checkbox" id="checkAll" v-model="check_all" />
              <label for="checkAll"> Tandai Semua </label>
            </div>
          </div>



          <!-- <div class="p-r-0 m-t-10 mt-md-0" :class="tipe_project == 1 ? 'col-md-7' : 'col-md-10'">
            <div class="pull-right" id="post-pagination">
              <pagination-component :data="page_info" />
            </div>
          </div> -->
        </div>
      </div>
      <div class="col-md-12 col-sm-12 mt-3" id="action-tersembunyi">
        <div class="custom-card d-flex justify-content-between bg-success-lighter bg-dark-secondary" style="gap: 28px;">
          <select name="sentiment_checked" v-model="sentiment_checked"
            class="form-sorting-post form-control form-control-sm bg-filter h-auto" style="width: max-content;">
            <option value="" disabled="" selected="">
              Ubah Sentimen
            </option>
            <option value="1">Positif</option>
            <option value="0">Netral</option>
            <option value="-1">Negatif</option>
          </select>
          <select name="emotion_checked" v-model="emotion_checked"
            class="form-sorting-post form-control form-control-sm bg-filter h-auto" style="width: max-content;">
            <option value="" disabled="" selected="">Ubah Emotion</option>
            <option value="0">Netral</option>
            <option value="1">Senang</option>
            <option value="2">Takut</option>
            <option value="3">Sedih</option>
            <option value="4">Marah</option>
          </select>
          <div class="border-line" style="border-right: 1px solid; height: 36px;" />
          <div class="d-flex" style="gap: 28px;">
            <button @click="validatePostAll()" class="btn-icon-action lg green" v-tooltip.top="'Validasi'">
              <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M22.16 10.74L20.8 9.16C20.54 8.86 20.33 8.3 20.33 7.9V6.2C20.33 5.14 19.46 4.27 18.4 4.27H16.7C16.31 4.27 15.74 4.06 15.44 3.8L13.86 2.44C13.17 1.85 12.04 1.85 11.34 2.44L9.76998 3.81C9.46998 4.06 8.89998 4.27 8.50998 4.27H6.77998C5.71998 4.27 4.84998 5.14 4.84998 6.2V7.91C4.84998 8.3 4.63998 8.86 4.38998 9.16L3.03998 10.75C2.45998 11.44 2.45998 12.56 3.03998 13.25L4.38998 14.84C4.63998 15.14 4.84998 15.7 4.84998 16.09V17.8C4.84998 18.86 5.71998 19.73 6.77998 19.73H8.50998C8.89998 19.73 9.46998 19.94 9.76998 20.2L11.35 21.56C12.04 22.15 13.17 22.15 13.87 21.56L15.45 20.2C15.75 19.94 16.31 19.73 16.71 19.73H18.41C19.47 19.73 20.34 18.86 20.34 17.8V16.1C20.34 15.71 20.55 15.14 20.81 14.84L22.17 13.26C22.75 12.57 22.75 11.43 22.16 10.74ZM16.76 10.11L11.93 14.94C11.79 15.08 11.6 15.16 11.4 15.16C11.2 15.16 11.01 15.08 10.87 14.94L8.44998 12.52C8.15998 12.23 8.15998 11.75 8.44998 11.46C8.73998 11.17 9.21998 11.17 9.50998 11.46L11.4 13.35L15.7 9.05C15.99 8.76 16.47 8.76 16.76 9.05C17.05 9.34 17.05 9.82 16.76 10.11Z"
                  fill="white" />
              </svg>
            </button>
            <button id="kliping-pdf" class="btn-icon-action lg orange">
              <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.86712 14.68C8.68312 14.68 8.55912 14.698 8.49512 14.716V15.894C8.57112 15.912 8.66612 15.917 8.79712 15.917C9.27612 15.917 9.57112 15.675 9.57112 15.266C9.57112 14.9 9.31712 14.68 8.86712 14.68ZM12.3541 14.692C12.1541 14.692 12.0241 14.71 11.9471 14.728V17.338C12.0241 17.356 12.1481 17.356 12.2601 17.356C13.0771 17.362 13.6091 16.912 13.6091 15.96C13.6151 15.13 13.1301 14.692 12.3541 14.692Z"
                  fill="white" />
                <path
                  d="M14.6001 2H6.6001C6.06966 2 5.56096 2.21071 5.18588 2.58579C4.81081 2.96086 4.6001 3.46957 4.6001 4V20C4.6001 20.5304 4.81081 21.0391 5.18588 21.4142C5.56096 21.7893 6.06966 22 6.6001 22H18.6001C19.1305 22 19.6392 21.7893 20.0143 21.4142C20.3894 21.0391 20.6001 20.5304 20.6001 20V8L14.6001 2ZM10.0981 16.19C9.7891 16.48 9.3331 16.61 8.8021 16.61C8.69914 16.6111 8.59623 16.6051 8.4941 16.592V18.018H7.6001V14.082C8.00355 14.0218 8.41122 13.9944 8.8191 14C9.3761 14 9.7721 14.106 10.0391 14.319C10.2931 14.521 10.4651 14.852 10.4651 15.242C10.4641 15.634 10.3341 15.965 10.0981 16.19ZM13.9051 17.545C13.4851 17.894 12.8461 18.06 12.0651 18.06C11.5971 18.06 11.2661 18.03 11.0411 18V14.083C11.4447 14.0241 11.8522 13.9963 12.2601 14C13.0171 14 13.5091 14.136 13.8931 14.426C14.3081 14.734 14.5681 15.225 14.5681 15.93C14.5681 16.693 14.2891 17.22 13.9051 17.545ZM17.6001 14.77H16.0681V15.681H17.5001V16.415H16.0681V18.019H15.1621V14.03H17.6001V14.77ZM14.6001 9H13.6001V4L18.6001 9H14.6001Z"
                  fill="white" />
              </svg>
            </button>
            <b-popover triggers="hover" target="kliping-pdf">
              <div>
                <h6>Klipping PDF</h6>
                <b-form-checkbox v-model="kliping.ad_value">
                  AD Value
                </b-form-checkbox>
                <b-form-checkbox v-model="kliping.pr_value">
                  PR Value
                </b-form-checkbox>
                <b-form-checkbox v-model="kliping.tipe_media">
                  Tipe Media
                </b-form-checkbox>
                <b-button @click="eksporSelectedKliping('pdf')" variant="success" class="mt-3 w-100">
                  Download
                </b-button>
              </div>
            </b-popover>
            <button id="kliping-word" class="btn-icon-action lg blue">
              <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.7861 14.552C12.1691 14.552 11.8091 15.139 11.8091 15.925C11.8091 16.716 12.1801 17.275 12.7921 17.275C13.4091 17.275 13.7631 16.687 13.7631 15.901C13.7631 15.175 13.4151 14.552 12.7861 14.552Z"
                  fill="white" />
                <path
                  d="M14.6001 2H6.6001C6.06966 2 5.56096 2.21071 5.18588 2.58579C4.81081 2.96086 4.6001 3.46957 4.6001 4V20C4.6001 20.5304 4.81081 21.0391 5.18588 21.4142C5.56096 21.7893 6.06966 22 6.6001 22H18.6001C19.1305 22 19.6392 21.7893 20.0143 21.4142C20.3894 21.0391 20.6001 20.5304 20.6001 20V8L14.6001 2ZM9.7551 17.454C9.3291 17.808 8.6821 17.975 7.8911 17.975C7.4161 17.975 7.0811 17.945 6.8531 17.915V13.944C7.26207 13.8851 7.67492 13.8574 8.0881 13.861C8.8561 13.861 9.3541 13.999 9.7431 14.293C10.1631 14.605 10.4271 15.103 10.4271 15.815C10.4271 16.59 10.1451 17.124 9.7551 17.454ZM12.7451 18C11.5451 18 10.8441 17.094 10.8441 15.942C10.8441 14.731 11.6171 13.826 12.8111 13.826C14.0521 13.826 14.7301 14.755 14.7301 15.871C14.7291 17.196 13.9251 18 12.7451 18ZM17.4001 17.238C17.6751 17.238 17.9811 17.177 18.1621 17.106L18.3001 17.819C18.1321 17.903 17.7541 17.993 17.2631 17.993C15.8661 17.993 15.1461 17.124 15.1461 15.972C15.1461 14.593 16.1291 13.826 17.3531 13.826C17.8271 13.826 18.1861 13.922 18.3481 14.006L18.1621 14.732C17.9186 14.6314 17.6575 14.5804 17.3941 14.582C16.6681 14.582 16.1041 15.02 16.1041 15.92C16.1041 16.729 16.5841 17.238 17.4001 17.238ZM14.6001 9H13.6001V4L18.6001 9H14.6001Z"
                  fill="white" />
                <path
                  d="M8.184 14.563C7.981 14.563 7.849 14.581 7.771 14.599V17.244C7.849 17.262 7.975 17.262 8.088 17.262C8.916 17.268 9.455 16.813 9.455 15.847C9.461 15.007 8.97 14.563 8.184 14.563Z"
                  fill="white" />
              </svg>
            </button>
            <b-popover triggers="hover" target="kliping-word">
              <div>
                <h6>Klipping DOCX</h6>
                <b-form-checkbox v-model="kliping.ad_value">
                  AD Value
                </b-form-checkbox>
                <b-form-checkbox v-model="kliping.pr_value">
                  PR Value
                </b-form-checkbox>
                <b-form-checkbox v-model="kliping.tipe_media">
                  Tipe Media
                </b-form-checkbox>
                <b-button @click="eksporSelectedKliping('docx')" variant="success" class="mt-3 w-100">
                  Download
                </b-button>
              </div>
            </b-popover>
            <button @click="sharePost" class="btn-icon-action lg teal" v-tooltip.top="'Bagikan'">
              <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18.6001 22C17.7668 22 17.0584 21.7083 16.4751 21.125C15.8918 20.5417 15.6001 19.8333 15.6001 19C15.6001 18.8833 15.6084 18.7623 15.6251 18.637C15.6418 18.5117 15.6668 18.3993 15.7001 18.3L8.6501 14.2C8.36676 14.45 8.0501 14.646 7.7001 14.788C7.3501 14.93 6.98343 15.0007 6.6001 15C5.76676 15 5.05843 14.7083 4.4751 14.125C3.89176 13.5417 3.6001 12.8333 3.6001 12C3.6001 11.1667 3.89176 10.4583 4.4751 9.875C5.05843 9.29167 5.76676 9 6.6001 9C6.98343 9 7.3501 9.071 7.7001 9.213C8.0501 9.355 8.36676 9.55067 8.6501 9.8L15.7001 5.7C15.6668 5.6 15.6418 5.48767 15.6251 5.363C15.6084 5.23833 15.6001 5.11733 15.6001 5C15.6001 4.16667 15.8918 3.45833 16.4751 2.875C17.0584 2.29167 17.7668 2 18.6001 2C19.4334 2 20.1418 2.29167 20.7251 2.875C21.3084 3.45833 21.6001 4.16667 21.6001 5C21.6001 5.83333 21.3084 6.54167 20.7251 7.125C20.1418 7.70833 19.4334 8 18.6001 8C18.2168 8 17.8501 7.92933 17.5001 7.788C17.1501 7.64667 16.8334 7.45067 16.5501 7.2L9.5001 11.3C9.53343 11.4 9.55843 11.5127 9.5751 11.638C9.59176 11.7633 9.6001 11.884 9.6001 12C9.6001 12.1167 9.59176 12.2377 9.5751 12.363C9.55843 12.4883 9.53343 12.6007 9.5001 12.7L16.5501 16.8C16.8334 16.55 17.1501 16.3543 17.5001 16.213C17.8501 16.0717 18.2168 16.0007 18.6001 16C19.4334 16 20.1418 16.2917 20.7251 16.875C21.3084 17.4583 21.6001 18.1667 21.6001 19C21.6001 19.8333 21.3084 20.5417 20.7251 21.125C20.1418 21.7083 19.4334 22 18.6001 22Z"
                  fill="white" />
              </svg>
            </button>
            <button v-if="news_trend > 0 && is_newstrend == 'manage'" @click="addNewsTrendModal"
              class="btn-icon-action lg purple" v-tooltip.top="'News Trend'">
              <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16.7901 2H8.4101C4.7701 2 2.6001 4.17 2.6001 7.81V16.18C2.6001 19.83 4.7701 22 8.4101 22H16.7801C20.4201 22 22.5901 19.83 22.5901 16.19V7.81C22.6001 4.17 20.4301 2 16.7901 2ZM17.4801 11.53C17.4801 11.92 17.1701 12.23 16.7801 12.23C16.3901 12.23 16.0801 11.92 16.0801 11.53V11.35L13.3601 14.07C13.2101 14.22 13.0101 14.29 12.8001 14.27C12.5901 14.25 12.4001 14.14 12.2901 13.96L11.2701 12.44L8.8901 14.82C8.7501 14.96 8.5801 15.02 8.4001 15.02C8.2201 15.02 8.0401 14.95 7.9101 14.82C7.6401 14.55 7.6401 14.11 7.9101 13.83L10.8901 10.85C11.0401 10.7 11.2401 10.63 11.4501 10.65C11.6601 10.67 11.8501 10.78 11.9601 10.96L12.9801 12.48L15.0901 10.37H14.9101C14.5201 10.37 14.2101 10.06 14.2101 9.67C14.2101 9.28 14.5201 8.97 14.9101 8.97H16.7701C16.8601 8.97 16.9501 8.99 17.0401 9.02C17.2101 9.09 17.3501 9.23 17.4201 9.4C17.4601 9.49 17.4701 9.58 17.4701 9.67V11.53H17.4801Z"
                  fill="white" />
              </svg>
            </button>
          </div>
          <div class="border-line" style="border-right: 1px solid; height: 36px;" />
          <button @click="deleteChecked" class="btn-icon-action lg red" v-tooltip.top="'Hapus'">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21.0702 5.23C19.4602 5.07 17.8502 4.95 16.2302 4.86V4.85L16.0102 3.55C15.8602 2.63 15.6402 1.25 13.3002 1.25H10.6802C8.35016 1.25 8.13016 2.57 7.97016 3.54L7.76016 4.82C6.83016 4.88 5.90016 4.94 4.97016 5.03L2.93016 5.23C2.51016 5.27 2.21016 5.64 2.25016 6.05C2.29016 6.46 2.65016 6.76 3.07016 6.72L5.11016 6.52C10.3502 6 15.6302 6.2 20.9302 6.73C20.9602 6.73 20.9802 6.73 21.0102 6.73C21.3902 6.73 21.7202 6.44 21.7602 6.05C21.7902 5.64 21.4902 5.27 21.0702 5.23Z"
                fill="white" />
              <path
                d="M19.2302 8.14C18.9902 7.89 18.6602 7.75 18.3202 7.75H5.68024C5.34024 7.75 5.00024 7.89 4.77024 8.14C4.54024 8.39 4.41024 8.73 4.43024 9.08L5.05024 19.34C5.16024 20.86 5.30024 22.76 8.79024 22.76H15.2102C18.7002 22.76 18.8402 20.87 18.9502 19.34L19.5702 9.09C19.5902 8.73 19.4602 8.39 19.2302 8.14ZM13.6602 17.75H10.3302C9.92024 17.75 9.58024 17.41 9.58024 17C9.58024 16.59 9.92024 16.25 10.3302 16.25H13.6602C14.0702 16.25 14.4102 16.59 14.4102 17C14.4102 17.41 14.0702 17.75 13.6602 17.75ZM14.5002 13.75H9.50024C9.09024 13.75 8.75024 13.41 8.75024 13C8.75024 12.59 9.09024 12.25 9.50024 12.25H14.5002C14.9102 12.25 15.2502 12.59 15.2502 13C15.2502 13.41 14.9102 13.75 14.5002 13.75Z"
                fill="white" />
            </svg>
          </button>
        </div>
      </div>
      <!-- <div class="col-md-12 col-sm-12 m-t-10" id="action-tersembunyi">
        <div class="bg-success-lighter p-l-10 p-t-5 p-b-5 p-r-10 rounded">
          <div class="row m-b-5">
            <div class="col-md-12">
              <b class="m-b-5">Aksi untuk item yang ditandai</b>
            </div>
          </div>
          <div style="
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              margin-left: 0px !important;
              margin-right: 0px !important;
            ">
            <div class="p-l-0 mb-1 mr-1">
              <div class="sentimen-checked-el" style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 100%;
                ">
                <select name="sentiment_checked" v-model="sentiment_checked"
                  class="form-sorting-post form-control form-control-sm bg-white">
                  <option value="" disabled="" selected="">
                    Ubah Sentimen
                  </option>
                  <option value="1">Positif</option>
                  <option value="0">Netral</option>
                  <option value="-1">Negatif</option>
                </select>
              </div>
            </div>
            <div class="p-l-0 mb-1 mr-1">
              <div class="sentimen-checked-el" style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 100%;
                ">
                <select name="emotion_checked" v-model="emotion_checked"
                  class="form-sorting-post form-control form-control-sm bg-white">
                  <option value="" disabled="" selected="">Ubah Emotion</option>
                  <option value="0">Netral</option>
                  <option value="1">Senang</option>
                  <option value="2">Takut</option>
                  <option value="3">Sedih</option>
                  <option value="4">Marah</option>
                </select>
              </div>
            </div>
            <div class="mr-auto p-l-0 mb-1">
              <button @click="validatePostAll()" class="btn btn-warning btn-icon-left mr-1">
                <i class="bi bi-patch-check"></i>
                <span>Validasi</span>
              </button>
              <button id="kliping-pdf" class="btn btn-danger btn-icon-left mr-1">
                <i class="bi bi-file-earmark-pdf md-18"></i>
                <span>Kliping PDF</span>
              </button>
              <b-popover triggers="hover" target="kliping-pdf">
                <div>
                  <b-form-checkbox v-model="kliping.ad_value">
                    AD Value
                  </b-form-checkbox>
                  <b-form-checkbox v-model="kliping.pr_value">
                    PR Value
                  </b-form-checkbox>
                  <b-form-checkbox v-model="kliping.tipe_media">
                    Tipe Media
                  </b-form-checkbox>
                  <b-button @click="eksporSelectedKliping('pdf')" variant="success" class="mt-3 w-100">
                    Download
                  </b-button>
                </div>
              </b-popover>
              <button id="kliping-word" class="btn btn-complete btn-icon-left mr-1">
                <i class="bi bi-file-earmark-word md-18"></i>
                <span>Kliping DOCX</span>
              </button>
              <b-popover triggers="hover" target="kliping-word">
                <div>
                  <b-form-checkbox v-model="kliping.ad_value">
                    AD Value
                  </b-form-checkbox>
                  <b-form-checkbox v-model="kliping.pr_value">
                    PR Value
                  </b-form-checkbox>
                  <b-form-checkbox v-model="kliping.tipe_media">
                    Tipe Media
                  </b-form-checkbox>
                  <b-button @click="eksporSelectedKliping('docx')" variant="success" class="mt-3 w-100">
                    Download
                  </b-button>
                </div>
              </b-popover>
              <button v-if="news_trend > 0 && is_newstrend == 'manage'" @click="addNewsTrendModal"
                class="btn btn-complete btn-icon-left">
                <i class="bi bi-plus md-18"></i>
                <span>News Trend</span>
              </button>
            </div>
            <div class="ml-auto p-l-0 mb-1">
              <button class="btn btn-danger pull-right btn-icon-left" @click="deleteChecked">
                <i class="bi bi-trash"></i> Hapus Posting
              </button>
              <button @click="sharePost" class="btn btn-success pull-right mr-1">
                <span class="bi bi-share mr-1" /> <span>Bagikan</span>
              </button>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="post-items">
      <div v-if="!data" class="col-md-12 col-sm-12 col-lg-12">
        <div class="alert alert-danger mt-3" id="errorApiEl" role="alert" align="center">
          <strong>Mohon maaf, data tidak tersedia! </strong> <br />
          Silahkan lakukan pencarian dengan parameter lain
        </div>
      </div>
      <div v-else class="scroller d-flex flex-column mt-3" style="max-height: 54rem; gap: 1rem;">
        <div v-for="(post, index) in data" :key="index" :index="index" class="card card-default col1 m-b-5"
          data-social="item" style="width: 100%; cursor: text !important">
          <div class="bg-white custom-card" style="cursor: text !important">
            <div class="d-flex flex-column flex-md-row post-content" style="gap: 1rem;">
              <div class="d-flex flex-column align-items-center" style="flex: none;" align="center">
                <div class="user-pic">
                  <img alt="Profile Image" :data-src-retina="post | showPicture" :data-src="post | showPicture"
                    :src="post | showPicture" class="img-shape" @error="imageUrlAlt" />
                  <!-- <div class="col-md-2 propic-badge" v-if="post.source">
                    <i :class="sosmed_icon[post.source] + ' icon-' + post.source" />
                  </div> -->
                  <div class="badge-validate" v-tooltip.bottom="{
                      html: 'validation-status-' + index,
                      class: 'tooltip-custom',
                    }">
                    <svg style="background:transparent !important;" width="22" height="22" viewBox="0 0 22 22"
                      fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M19.7633 9.845L18.5166 8.39667C18.2783 8.12167 18.0858 7.60834 18.0858 7.24167V5.68333C18.0858 4.71167 17.2883 3.91417 16.3166 3.91417H14.7583C14.4008 3.91417 13.8783 3.72167 13.6033 3.48333L12.155 2.23667C11.5225 1.69583 10.4866 1.69583 9.84497 2.23667L8.40581 3.4925C8.13081 3.72167 7.60831 3.91417 7.25081 3.91417H5.66497C4.69331 3.91417 3.89581 4.71167 3.89581 5.68333V7.25083C3.89581 7.60833 3.70331 8.12167 3.47414 8.39667L2.23664 9.85417C1.70497 10.4867 1.70497 11.5133 2.23664 12.1458L3.47414 13.6033C3.70331 13.8783 3.89581 14.3917 3.89581 14.7492V16.3167C3.89581 17.2883 4.69331 18.0858 5.66497 18.0858H7.25081C7.60831 18.0858 8.13081 18.2783 8.40581 18.5167L9.85414 19.7633C10.4866 20.3042 11.5225 20.3042 12.1641 19.7633L13.6125 18.5167C13.8875 18.2783 14.4008 18.0858 14.7675 18.0858H16.3258C17.2975 18.0858 18.095 17.2883 18.095 16.3167V14.7583C18.095 14.4008 18.2875 13.8783 18.5258 13.6033L19.7725 12.155C20.3041 11.5225 20.3041 10.4775 19.7633 9.845ZM14.8133 9.2675L10.3858 13.695C10.2575 13.8233 10.0833 13.8967 9.89997 13.8967C9.71664 13.8967 9.54247 13.8233 9.41414 13.695L7.19581 11.4767C6.92997 11.2108 6.92997 10.7708 7.19581 10.505C7.46164 10.2392 7.90164 10.2392 8.16747 10.505L9.89997 12.2375L13.8416 8.29584C14.1075 8.03 14.5475 8.03 14.8133 8.29584C15.0791 8.56167 15.0791 9.00167 14.8133 9.2675Z"
                        fill="white" />
                    </svg>
                  </div>
                </div>
                <span class="label text-white p-t-1 p-b-1 fs-12 mt-4 text-center"
                  :class="cekPers(post.id_account) ? 'bg-orange' : 'bg-purple'" style="width: 46px; font-weight: 400;">
                  {{ cekPers(post.id_account) ? 'Pers' : 'Non Pers' }}
                </span>
                <div :id="'validation-status-' + index" class="tooltip-content">
                  <p class="text-black">Status Validasi</p>
                  <p class="text-black">
                    Sentimen:
                    <b>
                      <span v-if="post.updated_sentiment" class="text-success">
                        Sudah divalidasi
                      </span>
                      <span v-else class="text-danger">
                        Belum divalidasi
                      </span>
                    </b>
                  </p>
                  <p class="text-black">
                    Emotion:
                    <b>
                      <span v-if="post.updated_emotion" class="text-success">
                        Sudah divalidasi
                      </span>
                      <span v-else class="text-danger">Belum divalidasi</span>
                    </b>
                  </p>
                </div>
              </div>
              <div class="d-flex flex-column w-100">
                <div class="d-flex flex-column">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center" style="gap: 8px;">
                      <svg v-if="post.source === 'twitter'" width="20" height="20" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_40_5680)">
                          <path class="path"
                            d="M6.2918 18.125C13.8371 18.125 17.9652 11.8723 17.9652 6.45158C17.9652 6.2758 17.9613 6.09611 17.9535 5.92033C18.7566 5.33958 19.4496 4.62024 20 3.79611C19.2521 4.12886 18.458 4.34618 17.6449 4.44064C18.5011 3.92745 19.1421 3.12126 19.4492 2.1715C18.6438 2.64883 17.763 2.98554 16.8445 3.16721C16.2257 2.50966 15.4075 2.07429 14.5164 1.92841C13.6253 1.78252 12.711 1.93424 11.9148 2.36011C11.1186 2.78598 10.4848 3.46229 10.1115 4.28446C9.73825 5.10663 9.64619 6.02888 9.84961 6.90861C8.21874 6.82677 6.62328 6.40312 5.16665 5.66511C3.71002 4.92711 2.42474 3.89123 1.39414 2.62463C0.870333 3.52773 0.710047 4.5964 0.945859 5.61344C1.18167 6.63048 1.79589 7.51957 2.66367 8.10002C2.01219 8.07933 1.37498 7.90393 0.804688 7.5883V7.63908C0.804104 8.58682 1.13175 9.50552 1.73192 10.239C2.3321 10.9725 3.16777 11.4755 4.09687 11.6625C3.49338 11.8276 2.85999 11.8517 2.2457 11.7328C2.50788 12.5479 3.01798 13.2608 3.70481 13.772C4.39164 14.2832 5.22093 14.5672 6.07695 14.5844C4.62369 15.726 2.82848 16.3451 0.980469 16.3422C0.652739 16.3417 0.325333 16.3216 0 16.2821C1.87738 17.4865 4.06128 18.1262 6.2918 18.125Z"
                            fill="white" />
                        </g>
                        <defs>
                          <clipPath id="clip0_40_5680">
                            <rect width="20" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <svg v-else-if="post.source === 'facebook'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path fill="#ffffff" d="M22 16.19c0 3.64-2.17 5.81-5.81 5.81H15c-.55 0-1-.45-1-1v-5.77c0-.27.22-.5.49-.5l1.76-.03c.14-.01.26-.11.29-.25l.35-1.91a.303.303 0 00-.3-.35l-2.13.03c-.28 0-.5-.22-.51-.49l-.04-2.45c0-.16.13-.3.3-.3l2.4-.04c.17 0 .3-.13.3-.3l-.04-2.4c0-.17-.13-.3-.3-.3l-2.7.04a2.996 2.996 0 00-2.95 3.05l.05 2.75c.01.28-.21.5-.49.51l-1.2.02c-.17 0-.3.13-.3.3l.03 1.9c0 .17.13.3.3.3l1.2-.02c.28 0 .5.22.51.49l.09 5.7c.01.56-.44 1.02-1 1.02h-2.3C4.17 22 2 19.83 2 16.18V7.81C2 4.17 4.17 2 7.81 2h8.38C19.83 2 22 4.17 22 7.81v8.38z"></path></svg>
                      <svg v-else-if="post.source === 'instagram'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2ZM12 15.88c-2.14 0-3.88-1.74-3.88-3.88 0-2.14 1.74-3.88 3.88-3.88 2.14 0 3.88 1.74 3.88 3.88 0 2.14-1.74 3.88-3.88 3.88Zm5.92-9c-.05.12-.12.23-.21.33-.1.09-.21.16-.33.21a.995.995 0 0 1-1.09-.21c-.09-.1-.16-.21-.21-.33A.995.995 0 0 1 16 6.5c0-.13.03-.26.08-.38.05-.13.12-.23.21-.33.23-.23.58-.34.9-.27.07.01.13.03.19.06.06.02.12.05.18.09.05.03.1.08.15.12.09.1.16.2.21.33.05.12.08.25.08.38s-.03.26-.08.38Z" fill="#ffffff"></path></svg>
                      <i v-else-if="post.source" class="text-white" :class="sosmed_icon[post.source] + ' icon-' + post.source" style="font-size: 20px;" />
                      <h6 @click="viewAccountDetail(post)" class="m-0 text-brown-300 line-clamp-1"
                        style="cursor: pointer !important;" v-html="sosmed_list.includes(post.source) &&
                      post.source != 'youtube'
                      ? post.account || post.apps.name
                      : post.title
                      ">
                      </h6>
                      <span class="bg-danger label text-white p-t-1 p-b-1 fs-10 m-l-5"
                        v-if="hoax_detection && sosmed_list.includes(post.source)">
                        HOAX 30%
                      </span>
                      <span class="bg-success label text-white p-t-1 p-b-1 fs-10 m-l-5"
                        v-if="hoax_detection && sosmed_list.includes(post.source)">
                        FAKTA 70%
                      </span>
                    </div>
                    <div v-if="isAdmin" class="form-check success m-b-0">
                      <input type="checkbox" :id="'check' + index" v-model="item_checked[index]" />
                      <label :for="'check' + index" />
                    </div>
                  </div>
                  <span class="text-gray-300">
                    {{
                      post.source == "media_cetak" ||
                        post.source == "media_tv"
                        ? convertDate(post.date.$date)
                        : dateindo(post.date.$date)
                    }}
                  </span>
                </div>
                <!-- <h5 class="row">
                  <span class="pull-left hoverable account-name col-10" style="cursor: pointer !important"
                    @click="viewAccountDetail(post)">
                    <span v-if="post.source === 'twitter'">@</span>
                    <span v-html="sosmed_list.includes(post.source) &&
                      post.source != 'youtube'
                      ? post.account || post.apps.name
                      : post.title
                      ">
                    </span>
                    <span>
                      {{
                      post.source == "media_cetak" ||
                        post.source == "media_tv"
                        ? convertDate(post.date.$date)
                        : dateindo(post.date.$date)
                    }}
                    </span>
                    <span v-if="cekPers(post.id_account)" class="bg-orange label text-white p-t-1 p-b-1 fs-10">
                      Pers
                    </span>
                  </span>
                  <div :id="'tanggal-release-' + index" class="tooltip-content">
                    <p class="text-black">Detail Tanggal</p>
                    <p class="text-black">
                      Publikasi:
                      <b>
                        <span class="text-success">
                          {{
                      post.source == "media_cetak" ||
                        post.source == "media_tv"
                        ? convertDate(post.date.$date)
                        : dateindo(post.date.$date)
                    }}</span>
                      </b>
                    </p>
                    <p class="text-black">
                      Tersimpan:
                      <b>
                        <span class="text-success">
                          {{
                        post.source == "media_cetak" ||
                          post.source == "media_tv"
                          ? newDateIndo(post.input_date.$date)
                          : newDateIndo(post.input_date.$date)
                      }}</span>
                      </b>
                    </p>
                  </div>
                  <span class="pull-right fs-12 col-2" style="margin-top: 2px !important">
                    <span v-tooltip.top="{
                        html: 'tanggal-release-' + index,
                        class: 'tooltip-custom',
                      }">
                      <i class="bi bi-calendar-event" />
                      {{
                      post.source == "media_cetak" ||
                        post.source == "media_tv"
                        ? convertDate(post.date.$date)
                        : dateindo(post.date.$date)
                    }}
                    </span>
                    <span v-if="'updated_emotion' in post || 'updated_sentiment' in post
                      " class="pull-right" style="margin-top: 0px !important; font-size: 22px" v-tooltip.top="{
                      html: 'validation-status-' + index,
                      class: 'tooltip-custom',
                    }">
                      <i class="i bi-patch-check text-success" />
                    </span>
                    <span v-else class="pull-right" style="margin-top: 0px !important; font-size: 22px" v-tooltip.top="{
                      html: 'validation-status-' + index,
                      class: 'tooltip-custom',
                    }">
                      <i class="i bi-patch-check text-secondary" />
                    </span>
                  </span>
                  <div class="clearfix" />
                </h5> -->
                <div class="clearfix"></div>
                <div class="d-flex align-items-center post-meta my-2" style="gap: 8px; flex-wrap: wrap;">
                  <div v-if="sosmed_list.includes(post.source)" class="engagement-detail d-flex" style="gap: 8px;">
                    <template v-if="post.source != 'youtube'">
                      <div class="d-flex align-items-center" style="gap: 8px; flex-wrap: wrap;"
                        v-for="(engagement, e_index) in post.engagement_detail" :key="e_index">
                        <span :title="post_attribute[e_index]" class="post-number text-nowrap"
                          v-tooltip.top="post_attribute[e_index]">
                          <i :class="post_meta[e_index]" />
                          {{ engagement | kmbFormatter }}
                        </span>
                        <div class="border-color" style="border-right: 1px solid; height: 16px;" />
                      </div>
                    </template>
                    <template v-else>
                      <span v-for="(engagement, e_index) in post.engagement_detail" :key="e_index"
                        :title="youtube_attribute[e_index]" class="m-r-5 post-number">
                        <i :class="youtube_meta[e_index]" />
                        {{ engagement | kmbFormatter }}
                      </span>
                    </template>
                    <span v-if="post.source == 'review'" class="post-number m-r-5" title="Score">
                      <i class="bi bi-star-fill" />
                      {{ post.score ? post.score : 0 | kmbFormatter }}
                    </span>
                    <span v-if="post.source == 'review'" class="post-number m-r-5" title="Score">
                      <i v-if="post.data_source == 'playstore'" class="bi bi-android m-r-5" />
                      <i v-else class="bi bi-apple m-r-5" />
                      <span v-if="post.data_source == 'playstore'">Play Store</span>
                      <span v-else>App Store</span>
                    </span>
                    <div v-if="post.source != 'review'" class="d-flex align-items-center" style="gap: 8px">
                      <span class="post-number text-nowrap" title="Followers" v-tooltip.top="'Followers'">
                        <i class="bi bi-people" />
                        {{ post.followers ? post.followers : 0 | kmbFormatter }}
                      </span>
                      <div class="border-color" style="border-right: 1px solid; height: 16px;" />
                    </div>
                    <div v-if="post.source != 'review'" class="d-flex align-items-center" style="gap: 8px">
                      <span class="post-number text-nowrap" v-tooltip.top="'Reach'">
                        <i class="bi bi-megaphone" />
                        {{ post.esmr ? post.esmr : 0 | kmbFormatter }}
                      </span>
                      <div class="border-color" style="border-right: 1px solid; height: 16px;" />
                    </div>
                    <div v-if="post.source != 'review'" class="d-flex align-items-center" style="gap: 8px">
                      <span class="post-number text-nowrap" v-tooltip.top="'Engagement'">
                        <i class="bi bi-share-fill" />
                        {{
                      post.engagement_count
                        ? post.engagement_count
                        : 0 | kmbFormatter
                    }}
                      </span>
                      <div class="border-color" style="border-right: 1px solid; height: 16px;" />
                    </div>
                    <!-- <span v-if="post.source != 'review'" class="post-number" title="Followers">
                      <i class="bi bi-people" />
                      {{ post.followers ? post.followers : 0 | kmbFormatter }}
                    </span>

                    <span v-if="post.source != 'review'" class="separator">|</span> -->
                    <!-- <span v-if="post.source != 'review'" class="m-l-5 post-number" title="Reach">
                      <i class="bi bi-megaphone" />
                      {{ post.esmr ? post.esmr : 0 | kmbFormatter }}
                    </span> -->

                    <!-- <span v-if="post.source != 'review'" class="m-r-10 m-l-5 post-number" title="Engagement">
                      <i class="bi bi-share-fill" />
                      {{
                      post.engagement_count
                        ? post.engagement_count
                        : 0 | kmbFormatter
                    }}
                    </span> -->
                  </div>
                  <div v-if="!sosmed_list.includes(post.source) &&
                      post.source != 'media_tv' &&
                      post.source != 'media_cetak'
                      " class="d-flex align-items-center" style="gap: 8px">
                    <span class="post-number hoverable" @click="viewAccountDetail(post)" v-tooltip.top="'Sumber'">
                      <i class="bi bi-globe-americas" />
                      {{ post.account ? post.account : "Tidak Tercantum" }}
                    </span>
                    <div class="border-color" style="border-right: 1px solid; height: 16px;" />
                  </div>
                  <div v-if="post.source == 'media_cetak'" class="d-flex align-items-center" style="gap: 8px">
                    <span class="post-number hoverable" v-tooltip.top="'Sumber Media Cetak'" @click="viewAccountDetail(post)">
                      <i class="bi bi-newspaper" />
                      {{ post.account ? post.account : "Tidak Tercantum" }}
                    </span>
                    <div class="border-color" style="border-right: 1px solid; height: 16px;" />
                  </div>
                  <div v-if="post.source == 'media_tv'" class="d-flex align-items-center" style="gap: 8px">
                    <span class="post-number hoverable" v-tooltip.top="'Channel TV'"
                      @click="viewAccountDetail(post)">
                      <i class="bi bi-tv" />
                      {{ post.account ? post.account : "Tidak Tercantum" }} -
                      {{ post.program ? post.program : "Tidak Tercantum" }}
                    </span>
                    <div class="border-color" style="border-right: 1px solid; height: 16px;" />
                  </div>
                  <div v-if="post.source == 'media_cetak' || post.source == 'media_tv'"
                    class="d-flex align-items-center" style="gap: 8px">
                    <span class="post-number" v-tooltip.top="'Jurnalis'">
                      <i class="bi bi-person" />
                      {{ post.journalist ? post.journalist : "Tidak Tercantum" }}
                    </span>
                    <div class="border-color" style="border-right: 1px solid; height: 16px;" />
                  </div>
                  <div v-if="post.source == 'news' && post.author" class="d-flex align-items-center" style="gap: 8px">
                    <span class="post-number" v-tooltip.top="'Jurnalis'">
                      <i class="bi bi-person" />
                      {{ post.author ? post.author : "Tidak Tercantum" }}
                    </span>
                    <div class="border-color" style="border-right: 1px solid; height: 16px;" />
                  </div>
                  <!-- <span
                    v-if="
                      post.source == 'media_cetak' || post.source == 'media_tv'
                    "
                    class="m-r-10 m-l-5 post-number"
                    title="Ad Value"
                  >
                    <b>AD</b> IDR
                    {{
                      post.rate_fc > 0 && post.rate_fc > 0
                        ? post.rate_fc
                        : post.rate_fc > 0 && post.rate_bw == 0
                        ? post.rate_fc
                        : post.rate_fc == 0 && post.rate_bw > 0
                        ? post.rate_bw
                        : 0 | kmbFormatter
                    }}
                  </span> -->
                  <div v-if="'ad_value' in post" class="d-flex align-items-center" style="gap: 8px">
                    <span class="post-number" v-tooltip.top="'AD Value'">
                      <b>AD</b> IDR {{ post.ad_value | kmbFormatter }}
                    </span>
                    <div class="border-color" style="border-right: 1px solid; height: 16px;" />
                  </div>
                  <div v-if="'pr_value' in post" class="d-flex align-items-center" style="gap: 8px">
                    <span class="post-number" v-tooltip.top="'Public Relations Value'">
                      <b>PR</b> IDR {{ post.pr_value | kmbFormatter }}
                    </span>
                    <div class="border-color" style="border-right: 1px solid; height: 16px;" />
                  </div>
                  <div v-if="'amec' in post" class="d-flex align-items-center" style="gap: 8px">
                    <span class="post-number" v-tooltip.top="'Amec Value'">
                      <b>a</b> {{ post.amec ? post.amec : 0 }}
                    </span>
                    <div v-if="post.source == 'media_cetak'" class="border-color"
                      style="border-right: 1px solid; height: 16px;" />
                  </div>
                  <div v-if="post.source == 'media_cetak'" class="d-flex align-items-center" style="gap: 8px">
                    <span class="post-number" title="Nomor Halaman">
                      <b>HAL</b> {{ post.page }}
                    </span>
                    <div class="border-color" style="border-right: 1px solid; height: 16px;" />
                  </div>
                  <div v-if="post.highlight" class="d-flex align-items-center" style="gap: 8px">
                    <span class="post-number" title="Serupa dengan posting di highlight">
                      <i class="bi bi-star-fill" style="color: #ffc107" />
                    </span>
                    <div class="border-color" style="border-right: 1px solid; height: 16px;" />
                  </div>
                  <div v-if="'emotion' in post &&
                      isAdmin &&
                      post.source != 'news' &&
                      post.source != 'media_cetak' &&
                      post.source != 'media_tv'
                      " :id="'emotion-' + index" class="tooltip-content" style="width: 100%">
                    <div style="width: 100%">
                      <div class="emot-wrapper" align="center" @click.prevent="changeEmotion(index, 0)">
                        <a href="#" class="text-black emotion-icon" title="Netral">
                          <i class="bi bi-emoji-neutral" />
                        </a>
                        <p class="text-secondary">Netral</p>
                      </div>
                      <div class="emot-wrapper" align="center" @click.prevent="changeEmotion(index, 1)">
                        <a href="#" class="text-success emotion-icon" title="Senang">
                          <i class="bi bi-emoji-smile" />
                        </a>
                        <p class="m-0 p-0 text-secondary">Senang</p>
                      </div>
                      <div class="emot-wrapper" align="center" @click.prevent="changeEmotion(index, 2)">
                        <a href="#" class="text-warning emotion-icon" title="Takut">
                          <i class="bi bi-emoji-dizzy" />
                        </a>
                        <p class="m-0 p-0 text-secondary">Takut</p>
                      </div>
                      <div class="emot-wrapper" align="center" @click.prevent="changeEmotion(index, 3)">
                        <a href="#" class="text-blue emotion-icon" title="Sedih">
                          <i class="bi bi-emoji-frown" />
                        </a>
                        <p class="m-0 p-0 text-secondary">Sedih</p>
                      </div>
                      <div class="emot-wrapper" align="center" @click.prevent="changeEmotion(index, 4)">
                        <a href="#" class="text-danger emotion-icon" title="Marah">
                          <i class="bi bi-emoji-angry" />
                        </a>
                        <p class="m-0 p-0 text-secondary">Marah</p>
                      </div>
                    </div>
                  </div>

                  <span v-if="'emotion' in post &&
                      isAdmin &&
                      post.source != 'news' &&
                      post.source != 'media_cetak' &&
                      post.source != 'media_tv'
                      " :id="'actual-emotion-' + index" class="post-number" v-tooltip.top.click="{
                      html: 'emotion-' + index,
                      class: 'tooltip-custom',
                    }">
                    <i v-if="post.emotion == 0" class="bi bi-emoji-neutral" style="font-size: 16px" title="Netral" />
                    <i v-if="post.emotion == 1" class="bi bi-emoji-smile text-success" style="font-size: 16px"
                      title="Senang" />
                    <i v-if="post.emotion == 2" class="bi bi-emoji-dizzy text-warning" style="font-size: 16px"
                      title="Takut" />
                    <i v-if="post.emotion == 3" class="bi bi-emoji-frown text-blue" style="font-size: 16px"
                      title="Sedih" />
                    <i v-if="post.emotion == 4" class="bi bi-emoji-angry text-danger" style="font-size: 16px"
                      title="Marah" />
                  </span>
                  <span v-else>
                    <span v-if="post.source != 'news' &&
                      post.source != 'media_cetak' &&
                      post.source != 'media_tv'
                      " :id="'actual-emotion-' + index" class="post-number">
                      <i v-if="post.emotion == 0" class="bi bi-emoji-neutral" style="font-size: 16px" title="Netral" />
                      <i v-if="post.emotion == 1" class="bi bi-emoji-smile text-success" style="font-size: 16px"
                        title="Senang" />
                      <i v-if="post.emotion == 2" class="bi bi-emoji-dizzy text-warning" style="font-size: 16px"
                        title="Takut" />
                      <i v-if="post.emotion == 3" class="bi bi-emoji-frown text-blue" style="font-size: 16px"
                        title="Sedih" />
                      <i v-if="post.emotion == 4" class="bi bi-emoji-angry text-danger" style="font-size: 16px"
                        title="Marah" />
                    </span>
                  </span>
                </div>
                <div class="m-r-10" v-if="isAdmin">
                  <select name="sentiment" :class="'select-sentimen py-1 px-2'" style="border-color: #3B4045;"
                    @change="changeSentimen(index)">
                    <option value="1" :selected="post.sentiment == 1">
                      Positif
                    </option>
                    <option value="0" :selected="post.sentiment == 0">
                      Netral
                    </option>
                    <option value="-1" :selected="post.sentiment == -1">
                      Negatif
                    </option>
                  </select>
                </div>
                <div class="" v-else>
                  <span class="label" :class="post.sentiment == 1
                      ? 'label-success'
                      : post.sentiment == 0
                        ? 'label-info'
                        : 'label-danger'
                      ">{{
                      post.sentiment == 1
                        ? "Positif"
                        : post.sentiment == 0
                          ? "Netral"
                          : "Negatif"
                    }}</span>
                </div>
                <div class="my-3">
                  <div class="text-content" :id="'text-content-' + index" v-html="writeContent(post.content)" />
                  <div v-if="post.in_medias != null" class="in-medias m-t-10 hide" id="media">
                    <div v-for="(in_media, in_media_index) in post.in_medias" :key="in_media_index"
                      class="post-img-wrapper" align="center">
                      <img v-if="in_media.type == 'photo'" :height="in_media.sizes.small.h"
                        :width="in_media.sizes.small.w" :src="in_media.media_url_https" alt="Image Post"
                        style="width: auto" />
                    </div>
                  </div>
                  <div v-if="post.photo" class="in-medias m-t-10 hide" id="media">
                    <img :src="post.photo" alt="" />
                  </div>
                </div>
                <div class="d-flex flex-column flex-md-row justify-content-between" style="gap: 8px;">
                  <div v-if="post.source == 'twitter'">
                    <div v-if="post.topics" class="d-flex align-items-center" style="gap: 8px;">
                      Topik:
                      <div v-for="(t, tIndex) in post.topics" :key="tIndex" class="badge-topik">
                        <span>{{ showTopicName(t.$oid) }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="post.source == 'facebook' ||
                      post.source == 'instagram' ||
                      post.source == 'youtube' ||
                      post.source == 'linkedin' ||
                      post.source == 'tiktok' ||
                      post.source == 'forum' ||
                      post.source == 'blog'
                      ">
                    <div v-if="post.topics" class="d-flex align-items-center" style="gap: 8px;">
                      Topik:
                      <div v-for="(t, tIndex) in post.topics" :key="tIndex" class="badge-topik">
                        <span>{{ showTopicName(t.$oid) }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div v-if="post.topics" class="d-flex align-items-center" style="gap: 8px;">
                      Topik:
                      <div v-for="(t, tIndex) in post.topics" :key="tIndex" class="badge-topik">
                        <span>{{ showTopicName(t.$oid) }}</span>
                        <span v-if="!isViewer" class="bi bi-x fa-lg" @click="deleteTopik(t.$oid, index)"
                          style="cursor: pointer"></span>
                        <!-- <span v-if="!isViewer" class="mr-1">|</span> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 col-12" v-if="post.source == 'twitter'">
                    <div class="in-reply" v-if="post.in_reply_to">
                      <div class="in-reply-to" v-if="post.in_reply_to.name && post.in_reply_to.id">
                        in reply to:
                        <a :href="'https://twitter.com/' +
                      post.in_reply_to.name +
                      '/status/' +
                      post.in_reply_to.id
                      " style="color: blue; opacity: 0.8 !important" target="__blank">@{{ post.in_reply_to.name
                          }}</a>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex" style="flex: none; gap: 6px">
                    <button @click.prevent="showDetailModal(index, post)" class="btn-icon-action brown"
                      v-tooltip.top="'Lihat Detail'">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7.9999 9.6C8.42425 9.6 8.83121 9.43143 9.13127 9.13137C9.43133 8.83131 9.5999 8.42435 9.5999 8C9.5999 7.57566 9.43133 7.16869 9.13127 6.86863C8.83121 6.56857 8.42425 6.4 7.9999 6.4C7.57556 6.4 7.16859 6.56857 6.86853 6.86863C6.56847 7.16869 6.3999 7.57566 6.3999 8C6.3999 8.42435 6.56847 8.83131 6.86853 9.13137C7.16859 9.43143 7.57556 9.6 7.9999 9.6Z"
                          fill="white" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M0.366455 8C1.38566 4.7544 4.41765 2.4 8.00005 2.4C11.5825 2.4 14.6145 4.7544 15.6337 8C14.6145 11.2456 11.5825 13.6 8.00005 13.6C4.41765 13.6 1.38566 11.2456 0.366455 8ZM11.2001 8C11.2001 8.84869 10.8629 9.66263 10.2628 10.2627C9.66268 10.8629 8.84875 11.2 8.00005 11.2C7.15136 11.2 6.33743 10.8629 5.73731 10.2627C5.1372 9.66263 4.80006 8.84869 4.80006 8C4.80006 7.15131 5.1372 6.33738 5.73731 5.73726C6.33743 5.13714 7.15136 4.8 8.00005 4.8C8.84875 4.8 9.66268 5.13714 10.2628 5.73726C10.8629 6.33738 11.2001 7.15131 11.2001 8Z"
                          fill="white" />
                      </svg>
                    </button>
                    <button v-if="post.is_validated != true" @click.prevent="validatePost(post._id)"
                      class="btn-icon-action green" v-tooltip.top="'Validasi'">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M14.3731 7.16L13.4664 6.10667C13.2931 5.90667 13.1531 5.53333 13.1531 5.26667V4.13333C13.1531 3.42667 12.5731 2.84666 11.8664 2.84666H10.7331C10.4731 2.84666 10.0931 2.70667 9.89309 2.53333L8.83976 1.62667C8.37976 1.23333 7.62643 1.23333 7.15976 1.62667L6.11309 2.54C5.91309 2.70667 5.53309 2.84666 5.27309 2.84666H4.11976C3.41309 2.84666 2.83309 3.42667 2.83309 4.13333V5.27333C2.83309 5.53333 2.69309 5.90667 2.52643 6.10667L1.62643 7.16667C1.23976 7.62667 1.23976 8.37333 1.62643 8.83333L2.52643 9.89333C2.69309 10.0933 2.83309 10.4667 2.83309 10.7267V11.8667C2.83309 12.5733 3.41309 13.1533 4.11976 13.1533H5.27309C5.53309 13.1533 5.91309 13.2933 6.11309 13.4667L7.16643 14.3733C7.62643 14.7667 8.37976 14.7667 8.84643 14.3733L9.89976 13.4667C10.0998 13.2933 10.4731 13.1533 10.7398 13.1533H11.8731C12.5798 13.1533 13.1598 12.5733 13.1598 11.8667V10.7333C13.1598 10.4733 13.2998 10.0933 13.4731 9.89333L14.3798 8.84C14.7664 8.38 14.7664 7.62 14.3731 7.16ZM10.7731 6.74L7.55309 9.96C7.45976 10.0533 7.33309 10.1067 7.19976 10.1067C7.06643 10.1067 6.93976 10.0533 6.84643 9.96L5.23309 8.34667C5.03976 8.15333 5.03976 7.83333 5.23309 7.64C5.42643 7.44666 5.74643 7.44666 5.93976 7.64L7.19976 8.9L10.0664 6.03333C10.2598 5.84 10.5798 5.84 10.7731 6.03333C10.9664 6.22667 10.9664 6.54666 10.7731 6.74Z"
                          fill="white" />
                      </svg>
                    </button>
                    <a v-if="post.source != 'media_cetak' &&
                      post.source != 'media_tv'
                      " :href="post.url" target="_blank" class="btn-icon-action blue" v-tooltip.top="'Kunjungi'">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M10.7935 1.33334H5.20683C2.78016 1.33334 1.3335 2.78001 1.3335 5.20668V10.7867C1.3335 13.22 2.78016 14.6667 5.20683 14.6667H10.7868C13.2135 14.6667 14.6602 13.22 14.6602 10.7933V5.20668C14.6668 2.78001 13.2202 1.33334 10.7935 1.33334ZM11.5002 8.22001C11.5002 8.49334 11.2735 8.72001 11.0002 8.72001C10.7268 8.72001 10.5002 8.49334 10.5002 8.22001V6.20668L5.3535 11.3533C5.2535 11.4533 5.12683 11.5 5.00016 11.5C4.8735 11.5 4.74683 11.4533 4.64683 11.3533C4.4535 11.16 4.4535 10.84 4.64683 10.6467L9.7935 5.50001H7.78016C7.50683 5.50001 7.28016 5.27334 7.28016 5.00001C7.28016 4.72668 7.50683 4.50001 7.78016 4.50001H11.0002C11.2735 4.50001 11.5002 4.72668 11.5002 5.00001V8.22001Z"
                          fill="white" />
                      </svg>
                    </a>
                    <button v-if="isAdmin" @click="deletePost(index)" class="btn-icon-action red"
                      v-tooltip.top="'Hapus'">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M14.0466 3.48665C12.9733 3.37998 11.8999 3.29998 10.8199 3.23998V3.23331L10.6733 2.36665C10.5733 1.75331 10.4266 0.833313 8.86661 0.833313H7.11994C5.56661 0.833313 5.41994 1.71331 5.31328 2.35998L5.17328 3.21331C4.55328 3.25331 3.93328 3.29331 3.31328 3.35331L1.95328 3.48665C1.67328 3.51331 1.47328 3.75998 1.49994 4.03331C1.52661 4.30665 1.76661 4.50665 2.04661 4.47998L3.40661 4.34665C6.89994 3.99998 10.4199 4.13331 13.9533 4.48665C13.9733 4.48665 13.9866 4.48665 14.0066 4.48665C14.2599 4.48665 14.4799 4.29331 14.5066 4.03331C14.5266 3.75998 14.3266 3.51331 14.0466 3.48665Z"
                          fill="white" />
                        <path
                          d="M12.8202 5.42669C12.6602 5.26002 12.4402 5.16669 12.2135 5.16669H3.78683C3.56016 5.16669 3.33349 5.26002 3.18016 5.42669C3.02683 5.59335 2.94016 5.82002 2.95349 6.05335L3.36683 12.8934C3.44016 13.9067 3.53349 15.1734 5.86016 15.1734H10.1402C12.4668 15.1734 12.5602 13.9134 12.6335 12.8934L13.0468 6.06002C13.0602 5.82002 12.9735 5.59335 12.8202 5.42669ZM9.10682 11.8334H6.88683C6.61349 11.8334 6.38683 11.6067 6.38683 11.3334C6.38683 11.06 6.61349 10.8334 6.88683 10.8334H9.10682C9.38016 10.8334 9.60682 11.06 9.60682 11.3334C9.60682 11.6067 9.38016 11.8334 9.10682 11.8334ZM9.66683 9.16669H6.33349C6.06016 9.16669 5.83349 8.94002 5.83349 8.66669C5.83349 8.39335 6.06016 8.16669 6.33349 8.16669H9.66683C9.94016 8.16669 10.1668 8.39335 10.1668 8.66669C10.1668 8.94002 9.94016 9.16669 9.66683 9.16669Z"
                          fill="white" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="row post-action m-t-10">
              <div class="col-md-12 col-sm-12 col-lg-12">
                <div class="row">
                  <div class="col-md-1 col-1">
                    <div v-if="isAdmin" class="form-check success m-b-0">
                      <input type="checkbox" :id="'check' + index" v-model="item_checked[index]" />
                      <label :for="'check' + index" />
                    </div>
                  </div>
                  <div v-if="post.source == 'twitter'" class="col-md-3 col-11">
                    <div v-if="post.topics">
                      Topik:
                      <div v-for="(t, tIndex) in post.topics" :key="tIndex"
                        class="btn btn-xs btn-rounded btn-default fs-10 m-r-5">
                        <span>{{ showTopicName(t.$oid) }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="post.source == 'facebook' ||
                      post.source == 'instagram' ||
                      post.source == 'youtube' ||
                      post.source == 'linkedin' ||
                      post.source == 'tiktok' ||
                      post.source == 'forum' ||
                      post.source == 'blog'
                      " class="col-md-5 col-11">
                    <div v-if="post.topics">
                      Topik:
                      <div v-for="(t, tIndex) in post.topics" :key="tIndex"
                        class="btn btn-xs btn-rounded btn-default fs-10 m-r-5">
                        <span>{{ showTopicName(t.$oid) }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-else class="col-md-5 col-11">
                    <div v-if="post.topics">
                      Topik:
                      <div v-for="(t, tIndex) in post.topics" :key="tIndex"
                        class="btn btn-xs btn-rounded btn-default fs-10 m-r-5">
                        <span v-if="!isViewer" class="bi bi-x text-danger fa-lg" @click="deleteTopik(t.$oid, index)">
                          &nbsp;</span>
                        <span v-if="!isViewer" class="mr-1">|</span>
                        <span>{{ showTopicName(t.$oid) }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 col-12" v-if="post.source == 'twitter'">
                    <div class="in-reply" v-if="post.in_reply_to">
                      <div class="in-reply-to" v-if="post.in_reply_to.name && post.in_reply_to.id">
                        in reply to:
                        <a :href="'https://twitter.com/' +
                      post.in_reply_to.name +
                      '/status/' +
                      post.in_reply_to.id
                      " style="color: blue; opacity: 0.8 !important" target="__blank">@{{ post.in_reply_to.name
                          }}</a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12 post-action-button-wrap" align="right">
                    <span class="m-r-10 text-success font-weight-bolder hoverable clickable"
                      @click.prevent="showDetailModal(index, post)">
                      <i class="bi bi-eye"></i>
                      Lihat Detail
                    </span>
                    <span v-if="post.is_validated != true"
                      class="m-r-10 text-warning font-weight-bold clickable hoverable"
                      @click.prevent="validatePost(post._id)" style="font-weight: 10px">
                      <i class="i bi-patch-check"></i>
                      Validasi
                    </span>
                    <a v-if="post.source != 'media_cetak' &&
                      post.source != 'media_tv'
                      " class="m-r-10 text-decoration-none font-weight-bolder hoverable" :href="post.url"
                      style="color: #17a2b8 !important; opacity: 1" target="_blank"><i
                        class="bi bi-box-arrow-up-right" />
                      Kunjungi</a>

                    <span class="m-r-10 font-weight-bolder text-danger hoverable clickable" v-if="isAdmin"
                      @click="deletePost(index)"><i class="bi bi-trash" /> Hapus</span>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="clearfix" />
    </div>
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-center w-100">
      <div class="">
        {{ paginationInfo() }}
      </div>
      <div class="">
        <pagination-component v-if="page_info" :data="page_info" class="pull-right" />
      </div>
    </div>
    <modal-detail-post-component v-if="isShowModalDetail" :id_stream="modal_post._id.$oid" :index="index"
      :key="modal_post_key" @close="closeModalDetail" />
    <modal-advance-search v-if="show_modal_advance" :key="modal_advance_key" @close="closeModalAdvance" />
    <modal-dynamic-component v-if="show_modal_dynamic" :key="modal_dynamic_key" modal_id="modal-edit-stream"
      :modal="modal_dynamic" :data="modal_dynamic_data" modal_size="modal-lg" />
    <floating-loader-component :key="float_loading_key" v-if="is_float_loading" :text="float_loading_text" />
  </div>
</template>

<script>
import $ from "jquery";
import modal_detail_post from "@/views/components/mention/modal_detail_post.vue";
import pagination from "@/views/components/pagination.vue";
import Multiselect from "vue-multiselect";
import gp from "@/plugins/generalPlugins.js";
import swal from "sweetalert";
import axios from "axios";
import notif from "@/assets/js/notif.js";
import { isMobile } from "mobile-device-detect";
import floating_loader from "@/views/components/floating_loader.vue";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_news_trend from "@/views/components/mention/modal_add_to_news_trend.vue";
import modal_advance_search from "@/views/components/mention/modal_advance_search.vue";
import post_share from "@/views/components/mention/modal_share_post.vue";
import * as linkify from "linkifyjs";
import linkifyHtml from "linkifyjs/html";
import hashtag from "linkifyjs/plugins/hashtag";
hashtag(linkify);
import Mark from "mark.js";
$.pgNotification = notif;

var sosmed_icon = new Array();
sosmed_icon["facebook"] = "bi bi-facebook";
sosmed_icon["twitter"] = "bi bi-twitter";
sosmed_icon["youtube"] = "bi bi-youtube";
sosmed_icon["instagram"] = "bi bi-instagram";
sosmed_icon["news"] = "bi bi-globe-americas";
sosmed_icon["blog"] = "bi bi-rss";
sosmed_icon["forum"] = "bi bi-chat-dots-fill";
sosmed_icon["media_cetak"] = "bi bi-newspaper";
sosmed_icon["media_tv"] = "bi bi-tv";
sosmed_icon["linkedin"] = "bi bi-linkedin";
sosmed_icon["tiktok"] = "bi bi-tiktok";
sosmed_icon["review"] = "bi bi-phone";

var post_meta = [];
post_meta["comment"] = "bi bi-chat-fill";
post_meta["view"] = "bi bi-eye";
post_meta["rt"] = "bi bi-repeat";
post_meta["share"] = "bi bi-share";
post_meta["like"] = "bi bi-heart-fill";
post_meta["fav"] = "bi bi-heart-fill";
post_meta["play"] = "bi bi-play";

var youtube_meta = [];
youtube_meta["comment"] = "bi bi-chat-fill";
youtube_meta["view"] = "bi bi-eye";
youtube_meta["like"] = "bi bi-hand-thumbs-up";
youtube_meta["dislike"] = "bi bi-hand-thumbs-down";
youtube_meta["favorite"] = "bi bi-heart-fill";

var post_attribute = [];
post_attribute["fav"] = "Like";
post_attribute["like"] = "Like";
post_attribute["rt"] = "Retweet";
post_attribute["share"] = "Share";
post_attribute["comment"] = "Comment";
post_attribute["view"] = "View";
post_attribute["play"] = "Play";

var youtube_attribute = [];
youtube_attribute["favorite"] = "Favorite";
youtube_attribute["like"] = "Like";
youtube_attribute["dislike"] = "Dislike";
youtube_attribute["comment"] = "Comment";
youtube_attribute["view"] = "View";

export default {
  name: "post_list",
  props: {
    posts: Object,
    string_limit: {
      type: String,
      default: "200",
    },
    pers: Array,
    topics: Object,
    highlights: {
      type: Array,
      default: function () {
        return [];
      },
    },
    keyword: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    Multiselect,
    "pagination-component": pagination,
    "floating-loader-component": floating_loader,
    "modal-advance-search": modal_advance_search,
    "modal-detail-post-component": modal_detail_post,
    "modal-dynamic-component": modal_dynamic,
  },
  data() {
    return {
      multiple_tier:
        "tier" in this.$route.query
          ? this.setInitialTier(this.$route.query.tier)
          : [],
      tier_options: [
        { name: "Tier 1", value: "1" },
        { name: "Tier 2", value: "2" },
        { name: "Tier 3", value: "3" },
        { name: "Tier 4", value: "4" },
      ],
      kliping: {
        ad_value: true,
        pr_value: true,
        tipe_media: true,
      },
      options: [
        { value: "Media Sosial", text: "Media Sosial" },
        { value: "Media Konvensional", text: "Media Konvensional" },
      ],
      index: null,
      data: this.posts.posts,
      page_info: this.posts.page_info,
      isShowModalDetail: false,
      modal_post: null,
      modal_post_key: 0,
      show_modal_advance: false,
      modal_advance_key: 100,
      sosmed_icon: sosmed_icon,
      check_all: false,
      stringLimit: this.string_limit,
      itemChecked: [],
      post_meta: post_meta,
      per_page: this.posts.page_info ? this.posts.page_info.limit : 10,
      sort: "sort" in this.$route.query ? this.$route.query.sort : "date",
      search: this.$route.query.q ? this.$route.query.q : null,
      isPers: "pers" in this.$route.query ? this.$route.query.pers : 2,
      tier: "tier" in this.$route.query ? this.$route.query.tier : 0,
      sosmed_list: [
        "facebook",
        "instagram",
        "twitter",
        "tiktok",
        "youtube",
        "linkedin",
        "forum",
        "blog",
        "review",
      ],
      post_attribute: post_attribute,
      youtube_meta: youtube_meta,
      youtube_attribute: youtube_attribute,
      sentiment_checked: "",
      emotion_checked: "",
      validate_checked: "",
      total_page: null,
      is_mobile: isMobile,
      show_modal_dynamic: false,
      item_checked: [],
      id_project: this.$store.getters.user.id_project,
      is_float_loading: false,
      highlight_list: [],
      is_highlight:
        "highlight" in this.$route.query
          ? this.$route.query.highlight == 1
            ? 1
            : 0
          : 0,
      tipe_project: this.$store.getters.user.project.project_detail.tipe,
      emotion_loading: false,
      modal_dynamic: null,
      modal_dynamic_key: 30,
      modal_dynamic_data: [],
      isFilter:
        "q" in this.$route.query ||
          "account" in this.$route.query ||
          "excludes" in this.$route.query ||
          "cakupan" in this.$route.query ||
          "pers" in this.$route.query ||
          "tier" in this.$route.query ||
          "sort" in this.$route.query ||
          "page" in this.$route.query ||
          "items" in this.$route.query
          ? true
          : false,
      news_trend: this.$store.getters.user.project.project_detail.news_trend,
      hoax_detection:
        "features" in this.$store.getters.user.project.project_detail
          ? this.$store.getters.user.project.project_detail.features
            .hoax_detection
          : 0,
      is_newstrend:
        this.$store.getters.user.capabilities != null
          ? this.$store.getters.user.capabilities.newstrend
          : "",
    };
  },
  methods: {
    setInitialTier(tier) {
      const result = tier.split(",").map((value) => ({
        name: `Tier ${value}`,
        value: value,
      }));
      return result;
    },
    tierChanged() {
      const result = this.multiple_tier.map((item) => item.value).join(",");
      if (result) {
        this.tier = result;
      } else {
        this.tier = "0";
      }
    },
    validatePost(id) {
      let self = this;
      let params = {
        _id: id.$oid,
        is_validated: 1,
      };
      event.preventDefault();
      swal({
        title: "Apakah anda yakin?",
        text: "Akan memvalidasi postingan ini.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
        className: "swal-custom",
      }).then((yess) => {
        if (yess) {
          let api = process.env.VUE_APP_API_URL + "validated-update";
          axios
            .put(api, params)
            .then(function (response) {
              if (response.status == 200) {
                self.$parent.isLoading = true;
                self.$parent.getData();
                self.$parent.getFiltersData();
                self.$parent.getFiltersSentiment();
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Postingan berhasil divalidasi.',
                    position: "top",
                    timeout: 4000,
                    type: "success",
                  })
                  .show();
              } else {
                swal(
                  "Error!",
                  "Gagal memvalidasi data. Silahkan coba lagi.",
                  "warning"
                );
              }
            })
            .catch(function () {
              swal(
                "Error!",
                "Terjadi kesalahan saat memvalidasi data. Silahkan coba lagi.",
                "warning"
              );
            });
        }
      });
    },
    validatePostAll() {
      let self = this;
      if (this.item_checked.includes(true)) {
        let post_checked_id = [];
        for (let key in this.item_checked) {
          if (this.item_checked[key] === true) {
            post_checked_id.push(this.data[key]._id.$oid);
          }
        }
        let params = {
          _id: post_checked_id,
          is_validated: 1,
        };

        swal({
          title: "Apakah anda yakin?",
          text: "Akan memvalidasi postingan yang ditandai.",
          icon: "warning",
          buttons: ["Tidak", "Ya"],
          dangerMode: true,
          className: "swal-custom",
        }).then((yess) => {
          if (yess) {
            let api = process.env.VUE_APP_API_URL + "validated-update-many";
            axios
              .post(api, params)
              .then((response) => {
                if (response.status == 200) {
                  self.$parent.isLoading = true;
                  self.$parent.getData();
                  self.$parent.getFiltersData();
                  self.$parent.getFiltersSentiment();
                  $("body")
                    .pgNotification({
                      style: "bar",
                      message:
                        '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Postingan berhasil divalidasi.',
                      position: "top",
                      timeout: 4000,
                      type: "success",
                    })
                    .show();
                } else {
                  swal(
                    "Error!",
                    "Gagal memvalidasi data. Silahkan coba lagi.",
                    "warning"
                  );
                }
              })
              .catch(() => {
                swal(
                  "Error!",
                  "Terjadi kesalahan saat memvalidasi data. Silahkan coba lagi.",
                  "warning"
                );
              });
          }
        });
      }
    },
    showAdvanceSearch: function () {
      this.show_modal_advance = true;
    },
    closeModalAdvance: function () {
      this.show_modal_advance = false;
    },
    deleteTopik: function (id, index) {
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus topik tersebut.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          let topics = [id];
          let api = process.env.VUE_APP_API_URL + "delete-stream-topic";
          let params = {
            _id: this.data[index]._id.$oid,
            topics: topics,
          };

          axios
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Topik berhasil dihapus.',
                    position: "top",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
                self.$parent.getData();
              }
            })
            .catch(function () {
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan.',
                  position: "top",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            });
        }
      });
    },
    viewAccountDetail: function (post) {
      let account = post;
      this.$router.push({
        path: "/detail-akun",
        query: { account: account.account, key: btoa(account.id_account) },
      });
    },
    showDetailModal: function (index, post) {
      this.index = index;
      this.modal_post = post;
      this.modal_post_key++;
      this.isShowModalDetail = true;
    },
    closeModalDetail: function () {
      this.isShowModalDetail = false;
    },
    dateindo: function (tanggal) {
      return gp.dateTimeID(tanggal);
    },
    newDateIndo: function (tanggal) {
      return gp.dateIndonesia(tanggal);
    },
    convertDate: function (tanggal) {
      return gp.convertDate(tanggal);
    },
    showAction: function () {
      $("#action-tersembunyi").slideDown();
    },
    hideAction: function () {
      this.check_all = false;
      for (let i = 0; i < this.data.length; i++) {
        $("#check" + i).prop("checked", false);
        this.item_checked[i] = false;
      }
      $("#action-tersembunyi").slideUp();
    },
    writeContent: function (text) {
      var batasKata = this.stringLimit;
      var newText = text.substring(0, batasKata);
      var last_index = newText.lastIndexOf(" ");
      var cekMark = text.substring(last_index);
      if (newText.length == batasKata) {
        if (cekMark.includes("mark")) {
          newText = newText.substring(0, last_index);
        }
        newText += "...";
      }

      if ("q" in this.$route.query) {
        newText = this.markString(newText);
      }
      // newText = this.createAutoLink(newText);
      newText = newText.replace(/\n/g, "<br />");

      return newText;
    },
    createAutoLink: function (text) {
      return linkifyHtml(text, {
        defaultProtocol: "https",
        ignoreTags: ["mark"],
        validate: {
          url: function (value) {
            return /^(http|ftp)s?:\/\//.test(value);
          },
        },
      });
    },
    changeSentimen: function (index) {
      event.preventDefault();
      var tgt = event.target;
      var val_before = this.data[index].sentiment;
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Akan mengubah sentimen posting ini.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
        className: "swal-custom",
      }).then((yess) => {
        if (yess) {
          var newValue = $(tgt)[0].value;
          let params = {
            _id: this.data[index]._id.$oid,
            sentiment: parseInt(newValue),
          };
          this.$parent.isLoading = true;
          let api = process.env.VUE_APP_API_URL + "post-sentiment";
          axios
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                self.data[index].updated_sentiment = 1;
                self.data[index].sentiment = parseInt(newValue);
                if ("updated_value" in response.data) {
                  self.data[index].pr_value =
                    response.data.updated_value.pr_value;
                }
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Sentimen berhasil diubah.',
                    position: "top",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
              }
            })
            .catch(function () {
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat mengubah sentimen.',
                  position: "top",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            })
            .finally(() => {
              this.$parent.isLoading = false;
            });
        } else {
          $(tgt).val(val_before);
          this.data[index].sentiment = val_before;
        }
      });
    },
    deletePost: function (index) {
      let self = this;
      let params = {
        _id: this.data[index]._id.$oid,
      };
      event.preventDefault();
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus posting ini.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
        className: "swal-custom",
      }).then((yess) => {
        if (yess) {
          let api = process.env.VUE_APP_API_URL + "post-delete";
          axios
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                self.$parent.isLoading = true;
                self.$parent.getData();
                self.$parent.getFiltersData();
                self.$parent.getFiltersSentiment();
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Posting berhasil dihapus.',
                    position: "top",
                    timeout: 4000,
                    type: "success",
                  })
                  .show();
              } else {
                swal(
                  "Error!",
                  "Gagal menghapus data. Silahkan coba lagi.",
                  "warning"
                );
              }
            })
            .catch(function () {
              swal(
                "Error!",
                "Terjadi kesalahan saat menghapus data. Silahkan coba lagi.",
                "warning"
              );
            });
        }
      });
    },
    thousandSeparator: function (str) {
      return gp.thousandSeparator(str);
    },
    imageUrlAlt: function () {
      event.target.src = "/assets/img/profiles/default.png";
    },
    paginationInfo: function () {
      let text = "";
      if (this.page_info != null) {
        let data_start =
          this.page_info.limit * this.page_info.page -
          (this.page_info.limit - 1);
        let data_end = this.page_info.limit * this.page_info.page;
        if (data_end > this.page_info.total) {
          data_end = this.page_info.total;
        }
        text =
          "Menampilkan " +
          data_start +
          " Sampai " +
          data_end +
          " dari " +
          this.thousandSeparator(this.page_info.total);
      }

      return text;
    },
    cekPers: function (_id) {
      if (this.pers != null) {
        return this.pers.includes(_id);
      } else {
        return false;
      }
    },
    searchPost() {
      let text = this.search;
      if ("q" in this.$route.query) {
        let queries = JSON.parse(JSON.stringify(this.$route.query));
        queries.q = text;
        if (text == "") {
          this.deleteParam("q");
        } else {
          queries.page = 1;
          this.$router.replace({ query: queries });
          this.isFilter = true;
        }
      } else {
        if (text) {
          this.isFilter = true;
          this.$router.replace({
            query: Object.assign({}, this.$route.query, { q: text }),
          });
        }
      }
    },
    resetFilter() {
      this.isFilter = false;
      this.search = "";
      if ("account" in this.$route.query) {
        this.deleteParam("account");
      }
      if ("excludes" in this.$route.query) {
        this.deleteParam("excludes");
      }
      if ("cakupan" in this.$route.query) {
        this.deleteParam("cakupan");
      }
      if ("tier" in this.$route.query) {
        this.deleteParam("tier");
      }
      if ("sort" in this.$route.query) {
        this.deleteParam("sort");
      }
      if ("pers" in this.$route.query) {
        this.deleteParam("pers");
      }
      if ("page" in this.$route.query) {
        this.deleteParam("page");
      }
      if ("items" in this.$route.query) {
        this.deleteParam("items");
      }
      this.searchPost();
    },
    deleteParam: function (key) {
      let queries = this.$route.query;
      delete queries[key];
      let self = this;
      let current_path = this.$route.path;
      this.$router
        .replace(current_path)
        .then(self.$router.replace({ query: queries }));
    },
    showTopicName: function (_id) {
      if (this.topics != null) {
        for (let grup in this.topics.formed) {
          for (let topic in this.topics.formed[grup].topics) {
            if (_id == topic) {
              return this.topics.formed[grup].topics[topic];
            }
          }
        }
        if (_id in this.topics.socmed) {
          return this.topics.socmed[_id];
        } else {
          return "Topik Dihapus";
        }
      } else {
        return "Topik Dihapus";
      }
    },
    deleteChecked: function () {
      if (this.item_checked.includes(true)) {
        let self = this;
        let post_checked_id = [];
        for (let key in this.item_checked) {
          if (this.item_checked[key] === true) {
            post_checked_id.push(this.data[key]._id.$oid);
          }
        }
        let params = {
          _id: post_checked_id,
        };

        event.preventDefault();

        swal({
          title: "Apakah anda yakin?",
          text: "Akan menghapus posting yang ditandai.",
          icon: "warning",
          buttons: ["Tidak", "Ya"],
          dangerMode: true,
          className: "swal-custom",
        }).then((yess) => {
          if (yess) {
            let api = process.env.VUE_APP_API_URL + "post-delete-many";
            axios
              .post(api, params)
              .then((response) => {
                if (response.status == 200) {
                  self.$parent.isLoading = true;
                  if (
                    this.page_info.page == this.total_page &&
                    this.page_info.page > 1 &&
                    this.data.length == post_checked_id.length
                  ) {
                    let current_page = this.page_info.page - 1;
                    let queries = JSON.parse(JSON.stringify(this.$route.query));
                    queries.page = current_page;
                    this.$router.replace({ query: queries });
                  } else {
                    self.$parent.getData();
                    self.$parent.getFiltersData();
                    self.$parent.getFiltersSentiment();
                  }

                  $("body")
                    .pgNotification({
                      style: "bar",
                      message:
                        '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Posting berhasil dihapus.',
                      position: "top",
                      timeout: 5000,
                      type: "success",
                    })
                    .show();
                } else {
                  swal(
                    "Error!",
                    "Gagal menghapus data. Silahkan coba lagi.",
                    "warning"
                  );
                }
              })
              .catch(() => {
                swal(
                  "Error!",
                  "Terjadi kesalahan saat menghapus data. Silahkan coba lagi.",
                  "warning"
                );
              });
          }
        });
      }
    },
    changeSentimentChecked: function (sentiment_id) {
      if (this.item_checked.includes(true)) {
        let post_checked_id = [];
        for (let key in this.item_checked) {
          if (this.item_checked[key] === true) {
            post_checked_id.push(this.data[key]._id.$oid);
          }
        }
        let params = {
          _id: post_checked_id,
          sentiment: parseInt(sentiment_id),
        };
        swal({
          title: "Apakah anda yakin?",
          text: "Akan mengubah sentimen posting yang ditandai.",
          icon: "warning",
          buttons: ["Tidak", "Ya"],
          dangerMode: true,
          className: "swal-custom",
        }).then((yess) => {
          if (yess) {
            let api = process.env.VUE_APP_API_URL + "post-sentiment-many";
            axios
              .post(api, params)
              .then((response) => {
                if (response.status == 200) {
                  for (let key in this.item_checked) {
                    if (this.item_checked[key] === true) {
                      this.data[key].sentiment = sentiment_id;
                      this.data[key].updated_sentiment = 1;
                    }
                  }
                  $("body")
                    .pgNotification({
                      style: "bar",
                      message:
                        '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Sentimen posting berhasil diubah.',
                      position: "top",
                      timeout: 5000,
                      type: "success",
                    })
                    .show();
                } else {
                  swal(
                    "Error!",
                    "Gagal menghapus data. Silahkan coba lagi.",
                    "warning"
                  );
                }
              })
              .catch(() => {
                swal(
                  "Error!",
                  "Terjadi kesalahan saat menghapus data. Silahkan coba lagi.",
                  "warning"
                );
              })
              .finally(() => {
                this.hideAction();
                this.sentiment_checked = "";
              });
          } else {
            this.sentiment_checked = "";
          }
        });
      }
    },
    changeEmotionChecked: function (emotion_id) {
      if (this.item_checked.includes(true)) {
        let post_checked_id = [];
        for (let key in this.item_checked) {
          if (this.item_checked[key] === true) {
            post_checked_id.push(this.data[key]._id.$oid);
          }
        }
        let params = {
          _id: post_checked_id,
          emotion: parseInt(emotion_id),
        };
        swal({
          title: "Apakah anda yakin?",
          text: "Akan mengubah emotion posting yang ditandai.",
          icon: "warning",
          buttons: ["Tidak", "Ya"],
          dangerMode: true,
          className: "swal-custom",
        }).then((yess) => {
          if (yess) {
            let api = process.env.VUE_APP_API_URL + "post-emotion-many";
            axios
              .post(api, params)
              .then((response) => {
                if (response.status == 200) {
                  for (let key in this.item_checked) {
                    if (this.item_checked[key] === true) {
                      this.data[key].emotion = emotion_id;
                      this.data[key].updated_emotion = 1;
                    }
                  }
                  $("body")
                    .pgNotification({
                      style: "bar",
                      message:
                        '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Emotion posting berhasil diubah.',
                      position: "top",
                      timeout: 5000,
                      type: "success",
                    })
                    .show();
                } else {
                  swal(
                    "Error!",
                    "Gagal mengupdate data. Silahkan coba lagi.",
                    "warning"
                  );
                }
              })
              .catch(() => {
                swal(
                  "Error!",
                  "Terjadi kesalahan saat mengupdate data. Silahkan coba lagi.",
                  "warning"
                );
              })
              .finally(() => {
                this.hideAction();
                this.emotion_checked = "";
              });
          } else {
            this.emotion_checked = "";
          }
        });
      }
    },
    markString: function (content, marked_word = []) {
      let kata = [];
      if ("q" in this.$route.query) {
        kata = this.$route.query.q;
        kata = gp.extractPhrase(kata);
      }

      if (marked_word.length > 0) {
        marked_word.forEach((word) => {
          word = gp.extractPhrase(word);
          if (
            word.every((w) => content.toLowerCase().includes(w.toLowerCase()))
          ) {
            word.forEach((w) => {
              w = w.trim();
              kata.push(w);
            });
          }
        });
      }
      kata = [...new Set(kata)];
      kata.forEach(function (word) {
        word = word.replaceAll('"', "");
        word = word.trim();
        let reg_exp = new RegExp("(\\b" + word + "\\b)", "gi");
        content = content.replace(
          reg_exp,
          ` <mark data-markjs="true"> ${word}  </mark> `
        );
      });
      return content;
    },
    unmark: function () {
      var context = document.querySelector(".post-items");
      var instance = new Mark(context);
      instance.unmark();
    },
    eksporSelectedKliping: function (type) {
      let filterTrue = this.item_checked.filter((el) => el == true);
      if (filterTrue.length > 40) {
        $("body")
          .pgNotification({
            style: "bar",
            message:
              '<i class="bi bi-exclamation-circle"></i> <b>Perhatian !</b> Maks. Berita yang dapat dikliping dalam 1 file hanya 40 berita',
            position: "top",
            timeout: 5000,
            type: "danger",
          })
          .show();
      } else {
        if (this.item_checked.includes(true)) {
          let post_checked_id = [];
          for (let key in this.item_checked) {
            if (this.item_checked[key] === true) {
              post_checked_id.push(this.data[key]._id.$oid);
            }
          }

          if (post_checked_id.length > 0) {
            let api;
            let nama_file;

            if (type == "docx") {
              api =
                process.env.VUE_APP_API_URL +
                "docxSelectedClips/" +
                this.id_project;
              nama_file =
                "Online Media Clipping Reports - " +
                gp.date(Date.now()).format("YYYYMMDDHHmmss") +
                ".docx";
            } else {
              api =
                process.env.VUE_APP_API_URL +
                "printSelectedClips/" +
                this.id_project;
              nama_file =
                "Online Media Clipping Reports - " +
                gp.date(Date.now()).format("YYYYMMDDHHmmss") +
                ".pdf";
            }

            let param = {
              clipping_ids: btoa(post_checked_id.join(",")),
              time: gp.date(Date.now()).format("YYYYMMDDHHmmss"),
              ad_value: this.kliping.ad_value == true ? 1 : 0,
              pr_value: this.kliping.pr_value == true ? 1 : 0,
              tipe_media_source: this.kliping.tipe_media == true ? 1 : 0,
            };
            // open new tab
            const fileURL =
              api +
              "?clipping_ids=" +
              param.clipping_ids +
              "&time=" +
              param.time +
              "&ad_value=" +
              param.ad_value +
              "&pr_value=" +
              param.pr_value +
              "&tipe_media_source=" +
              param.tipe_media_source;

            const link = document.createElement("a");
            link.href = fileURL;
            link.target = "_blank";
            link.setAttribute("download", nama_file);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      }
    },
    highlightPost: function (index) {
      let params = {
        _id: this.data[index]._id.$oid,
      };
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghiglight posting ini.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
        className: "swal-custom",
      })
        .then((yess) => {
          if (yess) {
            let api = process.env.VUE_APP_API_URL + "highlight-add";
            this.$http
              .post(api, params)
              .then((response) => {
                if (response.status == 200) {
                  this.highlight_list.push({ $oid: params._id });
                  $("body")
                    .pgNotification({
                      style: "bar",
                      message:
                        '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Posting berhasil ditambahkan kedalam daftar highlight.',
                      position: "top",
                      timeout: 5000,
                      type: "success",
                    })
                    .show();
                } else {
                  swal(
                    "Error!",
                    "Gagal menghapus menghiglight posting. Silahkan coba lagi.",
                    "warning"
                  );
                }
              })
              .catch(function () {
                swal(
                  "Error!",
                  "Terjadi kesalahan saat menghiglight posting. Silahkan coba lagi.",
                  "warning"
                );
              });
          }
        })
        .catch(() => {
          swal(
            "Error!",
            "Terjadi kesalahan saat menghiglight posting. Silahkan coba lagi.",
            "warning"
          );
        });
    },
    unhighlightPost: function (index) {
      let params = {
        _id: this.data[index]._id.$oid,
      };
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus highlight posting ini.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
        className: "swal-custom",
      })
        .then((yess) => {
          if (yess) {
            let api = process.env.VUE_APP_API_URL + "highlight-remove";
            this.$http
              .post(api, params)
              .then((response) => {
                if (response.status == 200) {
                  this.getHighlight();
                  $("body")
                    .pgNotification({
                      style: "bar",
                      message:
                        '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Highlight berhasil dihilangkan.',
                      position: "top",
                      timeout: 5000,
                      type: "success",
                    })
                    .show();
                } else {
                  swal(
                    "Error!",
                    "Gagal menghapus menghiglight posting. Silahkan coba lagi.",
                    "warning"
                  );
                }
              })
              .catch(function () {
                swal(
                  "Error!",
                  "Terjadi kesalahan saat menghapus higlight posting. Silahkan coba lagi.",
                  "warning"
                );
              });
          }
        })
        .catch(() => {
          swal(
            "Error!",
            "Terjadi kesalahan saat menghapus higlight posting. Silahkan coba lagi.",
            "warning"
          );
        });
    },
    getHighlight: function () {
      let api =
        process.env.VUE_APP_API_URL + "highlight-ids/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          this.highlight_list = response.data;
        })
        .catch(() => {
          this.highlight_list = [];
        });
    },
    cekHiglight: function (id) {
      if (this.tipe_project == 1) {
        let is_higlight = false;
        if (this.highlight_list.length > 0) {
          is_higlight = this.highlight_list.find((obj) => obj.$oid == id);
        }
        if (is_higlight) {
          return true;
        }
      }
      return false;
    },
    changeEmotion: function (index, val) {
      if (!this.emotion_loading) {
        this.emotion_loading = true;
        let param = {
          _id: this.posts.posts[index]._id.$oid,
          emotion: parseInt(val),
        };
        let api = process.env.VUE_APP_API_URL + "post-emotion";
        this.$parent.isLoading = true;
        this.$http
          .post(api, param)
          .then((response) => {
            if (response.status == 200) {
              this.posts.posts[index].emotion = val;
              this.posts.posts[index].updated_emotion = 1;
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.$("#actual-emotion-" + index).trigger("click");
            this.emotion_loading = false;
            this.$parent.isLoading = false;
          });
      } else {
        alert("too fast dude!");
      }
    },
    sharePost: function () {
      let content =
        "Lihat apa yang Saya temukan di " + window.location.origin + " \n\n";
      for (let index in this.item_checked) {
        if (this.item_checked[index]) {
          let akun = this.sosmed_list.includes(this.data[index].source)
            ? this.data[index].account
            : this.data[index].title;
          let title = this.data[index].source == "twitter" ? "@" + akun : akun;
          content += title + "\n";

          if (this.sosmed_list.includes(this.data[index].source)) {
            content +=
              this.data[index].content
                .replace(/<[^>]*>/g, "")
                .substring(0, 140) + "...\n";
          }

          if (this.data[index].source == "media_cetak") {
            content +=
              window.location.origin +
              "/view?id=" +
              this.data[index]._id.$oid +
              "\n";
          } else if (this.data[index].source == "media_tv") {
            content +=
              window.location.origin +
              "/view?id=" +
              this.data[index]._id.$oid +
              "\n";
          } else if (this.data[index].source == "news") {
            content +=
              window.location.origin +
              "/view?id=" +
              this.data[index]._id.$oid +
              "\n";
          } else {
            content += this.data[index].url;
          }
          content += "\n\n";
        }
      }
      this.modal_dynamic = {
        title: "Share Post",
        subtitle: "",
        component: post_share,
      };
      let data = [];
      data["content"] = content;
      this.modal_dynamic_data = data;
      this.modal_dynamic_key++;
      this.show_modal_dynamic = true;
    },
    addNewsTrendModal: function () {
      let post_checked = [];
      for (let key in this.item_checked) {
        if (this.item_checked[key] === true) {
          if (post_checked.length > 0) {
            let tanggal = gp.timestampTodate(this.data[key].date.$date);
            let index = post_checked.findIndex(
              (obj) => obj.tanggal === tanggal
            );
            if (index != -1) {
              post_checked[index].streams.push(this.data[key]._id.$oid);
            } else {
              post_checked.push({
                tanggal: gp.timestampTodate(this.data[key].date.$date),
                streams: [this.data[key]._id.$oid],
              });
            }
          } else {
            post_checked.push({
              tanggal: gp.timestampTodate(this.data[key].date.$date),
              streams: [this.data[key]._id.$oid],
            });
          }
        }
      }
      this.modal_dynamic_data = post_checked;
      this.modal_dynamic = {
        title: "News Trend",
        subtitle: "",
        component: modal_news_trend,
      };
      if (!this.show_modal_dynamic) {
        this.show_modal_dynamic = true;
      } else {
        this.modal_dynamic_key++;
      }
    },
    autoHighlight() {
      for (let i in this.data) {
        let text = this.data[i].content;
        let keywords = [];
        if (this.data[i].topics) {
          for (let j in this.data[i].topics) {
            const topic_id = this.data[i].topics[j].$oid;
            if (
              this.keyword &&
              this.keyword[topic_id] &&
              this.keyword[topic_id]["keywords"]
            ) {
              keywords = [...keywords, ...this.keyword[topic_id]["keywords"]];
            }
          }
          this.data[i].content = this.markString(text, keywords);
        }
      }
    },
  },
  filters: {
    decimalFormater: function (value) {
      if (!value) return "";
      value = value.toFixed(2);
      return value;
    },
    showPicture: function (post) {
      let pro_pic;
      switch (post.source) {
        case "twitter":
          pro_pic = post.profile_image;
          break;
        case "instagram":
          pro_pic = post.profile_image;
          break;
        case "facebook":
          pro_pic = post.profile_photo;
          break;
        case "youtube":
          pro_pic = post.thumbnails;
          break;
        case "linkedin":
          pro_pic = post.profile_picture;
          break;
        case "tiktok":
          pro_pic = post.profile_picture;
          break;
        default:
          pro_pic = "/assets/img/profiles/default.png";
          break;
      }

      if (pro_pic == null) {
        pro_pic = "/assets/img/profiles/default.png";
      }
      return pro_pic;
    },
    kmbFormatter: function (number) {
      return gp.kmbFormatter(number);
    },
  },
  watch: {
    sentiment_checked: function () {
      if (this.sentiment_checked) {
        this.changeSentimentChecked(this.sentiment_checked);
      }
    },
    emotion_checked: function () {
      if (this.emotion_checked) {
        this.changeEmotionChecked(this.emotion_checked);
      }
    },
    per_page(item) {
      if ("items" in this.$route.query) {
        let queries = JSON.parse(JSON.stringify(this.$route.query));
        queries.items = item;
        this.$router.replace({ query: queries });
      } else {
        this.$router.replace({
          query: Object.assign({}, this.$route.query, { items: item }),
        });
      }
    },
    sort(sort_by) {
      if ("sort" in this.$route.query) {
        if (this.$route.query.sort != sort_by) {
          let queries = JSON.parse(JSON.stringify(this.$route.query));
          queries.sort = sort_by;
          this.$router.replace({ query: queries });
        }
      } else {
        this.$router.replace({
          query: Object.assign({}, this.$route.query, { sort: sort_by }),
        });
      }
      this.sort = sort_by;
    },
    isPers(is_pers) {
      let params = this.$route.query;
      params.page = 1;
      if (is_pers == 2) {
        this.deleteParam("pers");
        this.deleteParam("tier");
      } else if (is_pers == 0) {
        this.deleteParam("tier");
        this.$router.replace({
          query: Object.assign({}, params, { pers: is_pers }),
        });
      } else {
        this.$router.replace({
          query: Object.assign({}, params, { pers: is_pers }),
        });
      }
    },
    tier(tier) {
      let params = this.$route.query;
      params.page = 1;
      if (tier != 0) {
        this.$router.replace({
          query: Object.assign({}, params, { tier: tier }),
        });
      } else {
        this.deleteParam("tier");
      }
    },
    is_highlight() {
      if ("highlight" in this.$route.query) {
        let queries = JSON.parse(JSON.stringify(this.$route.query));
        queries.highlight = this.is_highlight ? 1 : 0;
        this.$router.replace({ query: queries });
      } else {
        let highlight = this.is_highlight ? 1 : 0;
        let params = this.$route.query;
        params.page = 1;
        this.$router.replace({
          query: Object.assign({}, params, { highlight: highlight }),
        });
      }
    },
    itemChecked() {
      if (this.itemChecked.length == 0) {
        this.check_all = false;
      }
      if (this.itemChecked.length == this.data.length) {
        this.check_all = true;
      }
    },
    check_all() {
      if (this.check_all == true) {
        for (let i = 0; i < this.data.length; i++) {
          this.item_checked[i] = true;
        }
        this.showAction();
      } else {
        this.hideAction();
      }
    },
    item_checked() {
      if (this.item_checked.includes(true)) {
        this.showAction();
      } else {
        $("#action-tersembunyi").slideUp();
      }
    },
  },
  computed: {
    isAdmin: function () {
      let user_role = this.$store.getters.user.role;
      if (user_role == 2 || user_role == 3) {
        return true;
      }
      return false;
    },
    isViewer: function () {
      let user_role = this.$store.getters.user.role;
      if (user_role == 4) {
        return true;
      }
      return false;
    },
  },
  created() {
    if ("q" in this.$route.query) {
      this.isFilter = true;
    }
    window.addEventListener("keydown", (e) => {
      if (e.key == "Escape") {
        this.isShowModalDetail = false;
      }
    });
  },
  mounted: function () {
    this.autoHighlight();
    let self = this;
    $(".post-wrapper").on("#modal_sumber hidden.bs.modal", function () {
      self.isShowModalDetail = false;
    });
  },
};
</script>

<style>
.tooltip-custom {
  background-color: rgb(255, 255, 255) !important;
}

.emotion-icon:hover {
  color: none;
}

.emotion-icon {
  font-size: 22px;
}
</style>

<style scoped>
@import "../../../../public/assets/plugins/bootstrap-social/bootstrap-social.css";

.perpage-el {
  padding: 0px;
}

.perpage-el i {
  font-size: 18px;
}

.text-content {
  text-align: justify;
}

.form-sorting-post {
  font-size: 12px;
  cursor: pointer;
  background-color: #fff;
  background-image: none;
  border: 1px solid rgba(33, 33, 33, 0.14);
  border-top-color: rgba(33, 33, 33, 0.21);
  font-family: -apple-system, BlinkMacSystemFont, "Inter UI", "Segoe UI",
    "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
    "Helvetica Neue", sans-serif, sans-serif;
  -webkit-appearance: button;
  color: #212121;
  outline: 0;
  padding: 6px 8px;
  line-height: 16px;
  font-size: 14px;
  font-weight: normal;
  vertical-align: middle;
  min-height: 32px;
  -webkit-transition: all 0.12s ease;
  transition: all 0.12s ease;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  -webkit-transition: background 0.2s linear 0s;
  transition: background 0.2s linear 0s;
}

.input-group-text {
  font-size: 12px;
}

.post-items {
  margin-bottom: 20px;
}

.select2-container {
  z-index: 1 !important;
}

.user-pic {
  width: 60px;
  height: 60px;
  position: relative;
}

.img-shape {
  height: auto !important;
  width: 100% !important;
  border-radius: 4px;
  border: 1px #ccc solid;
  max-height: 60px;
  max-width: 60px;
}

.badge-validate {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #6C757D;
  position: absolute;
  top: 44px;
  left: 14px;
}

.badge-validate.success {
  background-color: #0E9F6E;
}

.bg-purple {
  background-color: #B572E8;
}

.twitter-border {
  border: 2px solid skyblue;
}

.post-action {
  display: block;
}

.select-sentimen {
  background: none;
  border-radius: 3px;
  font-size: 12px;
  padding: 1px 5px;
  font-weight: bold;
  opacity: 1 !important;
  cursor: pointer;
}

.sentimen1 {
  border-color: #28a745;
  color: #28a745;
}

.sentimen-1 {
  border-color: #dc3545;
  color: #dc3545;
}

.sentimen0 {
  border-color: #0e6d87;
  color: #0e6d87;
}

.propic-badge {
  position: absolute;
  right: 15%;
  bottom: 0px;
  font-size: 12px;
  background: white;
  border-radius: 50%;
  border: 2px #eee solid;
  padding: 1px;
  height: 25px;
  width: 25px;
  max-width: 100%;
}

.post-content:hover .post-number {
  color: black;
  cursor: pointer;
  opacity: 1 !important;
}

.active {
  background: #0f8ff9 !important;
  color: #fff !important;
}

a:hover {
  color: blue !important;
  opacity: 1 !important;
}

#action-tersembunyi {
  display: none;
}

@media (max-width: 600px) {
  .propic-badge {
    position: absolute;
    right: 40%;
    top: 40px;
    font-size: 14px;
    background: white;
    border-radius: 50%;
    border: 1px #eee solid;
    padding: 2px 1px;
    height: 25px;
    width: 25px;
  }
}

select:after {
  content: " ";
  display: inline-block;
  width: 24px;
  height: 24px;
  background: blue;
}

.emot-wrapper {
  float: left;
  margin: 0px 5px;
  cursor: pointer;
}

.emot-wrapper:hover p {
  color: #0f8ff9 !important;
}

.emot-wrapper:hover a {
  color: #0f8ff9 !important;
}

select {
  cursor: pointer;
}

/* .post-text-content {
  padding-left: 5px;
} */
</style>
